import React, { createContext, useContext, useState, useEffect } from 'react';

// Language Context
const LanguageContext = createContext();

// Available languages - All Indian regional languages + English
export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी', flag: '🇮🇳' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी', flag: '🇮🇳' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', flag: '🇮🇳' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', flag: '🇮🇳' }
];

// Comprehensive translations for all languages
const translations = {
  // ==================== COMMON ====================
  appName: {
    en: 'Paras Rewards',
    hi: 'पारस रिवॉर्ड',
    mr: 'पारस रिवॉर्ड',
    gu: 'પારસ રિવૉર્ડ',
    ta: 'பாரஸ் ரிவார்ட்',
    te: 'పారస్ రివార్డ్',
    kn: 'ಪಾರಸ್ ರಿವಾರ್ಡ್',
    bn: 'পারস রিওয়ার্ড',
    pa: 'ਪਾਰਸ ਰਿਵਾਰਡ'
  },
  
  // ==================== NAVIGATION ====================
  home: {
    en: 'Home',
    hi: 'होम',
    mr: 'होम',
    gu: 'હોમ',
    ta: 'முகப்பு',
    te: 'హోమ్',
    kn: 'ಮುಖಪುಟ',
    bn: 'হোম',
    pa: 'ਹੋਮ'
  },
  dashboard: {
    en: 'Dashboard',
    hi: 'डैशबोर्ड',
    mr: 'डॅशबोर्ड',
    gu: 'ડેશબોર્ડ',
    ta: 'டாஷ்போர்டு',
    te: 'డాష్‌బోర్డ్',
    kn: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    bn: 'ড্যাশবোর্ড',
    pa: 'ਡੈਸ਼ਬੋਰਡ'
  },
  profile: {
    en: 'Profile',
    hi: 'प्रोफ़ाइल',
    mr: 'प्रोफाइल',
    gu: 'પ્રોફાઇલ',
    ta: 'சுயவிவரம்',
    te: 'ప్రొఫైల్',
    kn: 'ಪ್ರೊಫೈಲ್',
    bn: 'প্রোফাইল',
    pa: 'ਪ੍ਰੋਫਾਈਲ'
  },
  settings: {
    en: 'Settings',
    hi: 'सेटिंग्स',
    mr: 'सेटिंग्ज',
    gu: 'સેટિંગ્સ',
    ta: 'அமைப்புகள்',
    te: 'సెట్టింగ్‌లు',
    kn: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    bn: 'সেটিংস',
    pa: 'ਸੈਟਿੰਗਾਂ'
  },
  wallet: {
    en: 'Wallet',
    hi: 'वॉलेट',
    mr: 'वॉलेट',
    gu: 'વૉલેટ',
    ta: 'வாலட்',
    te: 'వాలెట్',
    kn: 'ವಾಲೆಟ್',
    bn: 'ওয়ালেট',
    pa: 'ਵਾਲਿਟ'
  },
  rewards: {
    en: 'Rewards',
    hi: 'पुरस्कार',
    mr: 'बक्षिसे',
    gu: 'પુરસ્કાર',
    ta: 'வெகுமதிகள்',
    te: 'రివార్డ్‌లు',
    kn: 'ಬಹುಮಾನಗಳು',
    bn: 'পুরস্কার',
    pa: 'ਇਨਾਮ'
  },
  marketplace: {
    en: 'Marketplace',
    hi: 'मार्केटप्लेस',
    mr: 'मार्केटप्लेस',
    gu: 'માર્કેટપ્લેસ',
    ta: 'சந்தை',
    te: 'మార్కెట్‌ప్లేస్',
    kn: 'ಮಾರುಕಟ್ಟೆ',
    bn: 'মার্কেটপ্লেস',
    pa: 'ਮਾਰਕੀਟਪਲੇਸ'
  },
  referrals: {
    en: 'Invite Friends',
    hi: 'दोस्तों को आमंत्रित करें',
    mr: 'मित्रांना आमंत्रित करा',
    gu: 'મિત્રોને આમંત્રિત કરો',
    ta: 'நண்பர்களை அழைக்கவும்',
    te: 'స్నేహితులను ఆహ్వానించండి',
    kn: 'ಸ್ನೇಹಿತರನ್ನು ಆಹ್ವಾನಿಸಿ',
    bn: 'বন্ধুদের আমন্ত্রণ করুন',
    pa: 'ਦੋਸਤਾਂ ਨੂੰ ਸੱਦੋ'
  },
  network: {
    en: 'Network',
    hi: 'नेटवर्क',
    mr: 'नेटवर्क',
    gu: 'નેટવર્ક',
    ta: 'நெட்வொர்க்',
    te: 'నెట్‌వర్క్',
    kn: 'ನೆಟ್‌ವರ್ಕ್',
    bn: 'নেটওয়ার্ক',
    pa: 'ਨੈੱਟਵਰਕ'
  },
  messages: {
    en: 'Messages',
    hi: 'संदेश',
    mr: 'संदेश',
    gu: 'સંદેશાઓ',
    ta: 'செய்திகள்',
    te: 'సందేశాలు',
    kn: 'ಸಂದೇಶಗಳು',
    bn: 'বার্তা',
    pa: 'ਸੁਨੇਹੇ'
  },
  notifications: {
    en: 'Notifications',
    hi: 'सूचनाएं',
    mr: 'सूचना',
    gu: 'સૂચનાઓ',
    ta: 'அறிவிப்புகள்',
    te: 'నోటిఫికేషన్లు',
    kn: 'ಅಧಿಸೂಚನೆಗಳು',
    bn: 'বিজ্ঞপ্তি',
    pa: 'ਸੂਚਨਾਵਾਂ'
  },
  
  // ==================== DASHBOARD ====================
  welcome: {
    en: 'Welcome',
    hi: 'स्वागत है',
    mr: 'स्वागत आहे',
    gu: 'સ્વાગત છે',
    ta: 'வரவேற்கிறோம்',
    te: 'స్వాగతం',
    kn: 'ಸ್ವಾಗತ',
    bn: 'স্বাগতম',
    pa: 'ਜੀ ਆਇਆਂ ਨੂੰ'
  },
  availableBalance: {
    en: 'Available Balance',
    hi: 'उपलब्ध शेष',
    mr: 'उपलब्ध शिल्लक',
    gu: 'ઉપલબ્ધ બેલેન્સ',
    ta: 'கிடைக்கும் இருப்பு',
    te: 'అందుబాటులో ఉన్న బ్యాలెన్స్',
    kn: 'ಲಭ್ಯವಿರುವ ಬ್ಯಾಲೆನ್ಸ್',
    bn: 'উপলব্ধ ব্যালেন্স',
    pa: 'ਉਪਲਬਧ ਬੈਲੇਂਸ'
  },
  todayEarned: {
    en: 'Today Earned',
    hi: 'आज कमाया',
    mr: 'आज कमावले',
    gu: 'આજે કમાયા',
    ta: 'இன்று சம்பாதித்தது',
    te: 'ఈరోజు సంపాదించింది',
    kn: 'ಇಂದು ಗಳಿಸಿದ್ದು',
    bn: 'আজ আয়',
    pa: 'ਅੱਜ ਕਮਾਇਆ'
  },
  totalEarned: {
    en: 'Total Earned',
    hi: 'कुल कमाई',
    mr: 'एकूण कमाई',
    gu: 'કુલ કમાણી',
    ta: 'மொத்த வருமானம்',
    te: 'మొత్తం సంపాదన',
    kn: 'ಒಟ್ಟು ಗಳಿಕೆ',
    bn: 'মোট আয়',
    pa: 'ਕੁੱਲ ਕਮਾਈ'
  },
  
  // ==================== QUICK ACTIONS ====================
  quickActions: {
    en: 'Quick Actions',
    hi: 'त्वरित कार्य',
    mr: 'त्वरित क्रिया',
    gu: 'ઝડપી ક્રિયાઓ',
    ta: 'விரைவு செயல்கள்',
    te: 'త్వరిత చర్యలు',
    kn: 'ತ್ವರಿತ ಕ್ರಿಯೆಗಳು',
    bn: 'দ্রুত কার্যক্রম',
    pa: 'ਤੁਰੰਤ ਕਾਰਵਾਈਆਂ'
  },
  earnRewards: {
    en: 'Earn Rewards',
    hi: 'पुरस्कार कमाएं',
    mr: 'बक्षिसे मिळवा',
    gu: 'પુરસ્કાર મેળવો',
    ta: 'வெகுமதிகள் பெறுங்கள்',
    te: 'రివార్డ్‌లు సంపాదించండి',
    kn: 'ಬಹುಮಾನಗಳನ್ನು ಗಳಿಸಿ',
    bn: 'পুরস্কার অর্জন করুন',
    pa: 'ਇਨਾਮ ਕਮਾਓ'
  },
  // tapGame translation kept for backward compatibility but text changed to Community
  tapGame: {
    en: 'Community',
    hi: 'Community',
    mr: 'Community',
    gu: 'Community',
    ta: 'Community',
    te: 'Community',
    kn: 'Community',
    bn: 'Community',
    pa: 'Community'
  },
  shop: {
    en: 'Shop',
    hi: 'खरीदारी',
    mr: 'खरेदी',
    gu: 'ખરીદી',
    ta: 'கடை',
    te: 'షాపింగ్',
    kn: 'ಶಾಪ್',
    bn: 'কেনাকাটা',
    pa: 'ਖਰੀਦਦਾਰੀ'
  },
  refer: {
    en: 'Refer',
    hi: 'रेफर करें',
    mr: 'रेफर करा',
    gu: 'રેફર કરો',
    ta: 'பரிந்துரைக்கவும்',
    te: 'రెఫర్ చేయండి',
    kn: 'ರೆಫರ್ ಮಾಡಿ',
    bn: 'রেফার করুন',
    pa: 'ਰੈਫਰ ਕਰੋ'
  },
  billPay: {
    en: 'Bill Pay',
    hi: 'बिल भरें',
    mr: 'बिल भरा',
    gu: 'બિલ ભરો',
    ta: 'பில் செலுத்து',
    te: 'బిల్ చెల్లించు',
    kn: 'ಬಿಲ್ ಪಾವತಿ',
    bn: 'বিল পে',
    pa: 'ਬਿੱਲ ਭਰੋ'
  },
  vouchers: {
    en: 'Vouchers',
    hi: 'वाउचर',
    mr: 'व्हाउचर्स',
    gu: 'વાઉચર્સ',
    ta: 'வவுச்சர்கள்',
    te: 'వౌచర్లు',
    kn: 'ವೌಚರ್‌ಗಳು',
    bn: 'ভাউচার',
    pa: 'ਵਾਊਚਰ'
  },
  
  // ==================== MARKETPLACE ====================
  merchandise: {
    en: 'Merchandise',
    hi: 'सामान',
    mr: 'उत्पादने',
    gu: 'માલસામાન',
    ta: 'பொருட்கள்',
    te: 'వస్తువులు',
    kn: 'ಸರಕುಗಳು',
    bn: 'পণ্য',
    pa: 'ਸਮਾਨ'
  },
  redeemYourPRC: {
    en: 'Redeem Your PRC',
    hi: 'अपने PRC का उपयोग करें',
    mr: 'तुमचे PRC वापरा',
    gu: 'તમારા PRC વાપરો',
    ta: 'உங்கள் PRC பயன்படுத்துங்கள்',
    te: 'మీ PRC వాడండి',
    kn: 'ನಿಮ್ಮ PRC ಬಳಸಿ',
    bn: 'আপনার PRC ব্যবহার করুন',
    pa: 'ਆਪਣਾ PRC ਵਰਤੋ'
  },
  redeemTagline: {
    en: 'Redeem your PRC on things you love',
    hi: 'अपने पसंदीदा चीज़ों पर PRC खर्च करें',
    mr: 'आवडत्या गोष्टींवर PRC वापरा',
    gu: 'તમને ગમતી વસ્તુઓ પર PRC વાપરો',
    ta: 'நீங்கள் விரும்புவதற்கு PRC பயன்படுத்துங்கள்',
    te: 'మీకు ఇష్టమైన వాటిపై PRC వాడండి',
    kn: 'ನಿಮಗೆ ಇಷ್ಟವಾದ ವಸ್ತುಗಳಿಗೆ PRC ಬಳಸಿ',
    bn: 'পছন্দের জিনিসে PRC খরচ করুন',
    pa: 'ਪਸੰਦੀਦਾ ਚੀਜ਼ਾਂ ਤੇ PRC ਖਰਚ ਕਰੋ'
  },
  prcBalance: {
    en: 'PRC Balance',
    hi: 'PRC बैलेंस',
    mr: 'PRC शिल्लक',
    gu: 'PRC બેલેન્સ',
    ta: 'PRC இருப்பு',
    te: 'PRC బ్యాలెన్స్',
    kn: 'PRC ಬ್ಯಾಲೆನ್ಸ್',
    bn: 'PRC ব্যালেন্স',
    pa: 'PRC ਬੈਲੇਂਸ'
  },
  searchProducts: {
    en: 'Search products...',
    hi: 'उत्पाद खोजें...',
    mr: 'उत्पादने शोधा...',
    gu: 'પ્રોડક્ટ્સ શોધો...',
    ta: 'தயாரிப்புகளைத் தேடுங்கள்...',
    te: 'ఉత్పత్తులు వెతకండి...',
    kn: 'ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...',
    bn: 'পণ্য খুঁজুন...',
    pa: 'ਉਤਪਾਦ ਖੋਜੋ...'
  },
  addToCart: {
    en: 'Add to Cart',
    hi: 'कार्ट में जोड़ें',
    mr: 'कार्टमध्ये जोडा',
    gu: 'કાર્ટમાં ઉમેરો',
    ta: 'கூடையில் சேர்',
    te: 'కార్ట్‌లో చేర్చు',
    kn: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ',
    bn: 'কার্টে যোগ করুন',
    pa: 'ਕਾਰਟ ਵਿੱਚ ਪਾਓ'
  },
  redeemNow: {
    en: 'Redeem Now',
    hi: 'अभी रिडीम करें',
    mr: 'आता रिडीम करा',
    gu: 'હમણાં રિડીમ કરો',
    ta: 'இப்போது பெறுங்கள்',
    te: 'ఇప్పుడు రీడీమ్ చేయండి',
    kn: 'ಈಗ ರಿಡೀಮ್ ಮಾಡಿ',
    bn: 'এখনই রিডিম করুন',
    pa: 'ਹੁਣੇ ਰੀਡੀਮ ਕਰੋ'
  },
  cart: {
    en: 'Cart',
    hi: 'कार्ट',
    mr: 'कार्ट',
    gu: 'કાર્ટ',
    ta: 'கூடை',
    te: 'కార్ట్',
    kn: 'ಕಾರ್ಟ್',
    bn: 'কার্ট',
    pa: 'ਕਾਰਟ'
  },
  checkout: {
    en: 'Place Order',
    hi: 'ऑर्डर करें',
    mr: 'ऑर्डर करा',
    gu: 'ઓર્ડર કરો',
    ta: 'ஆர்டர் செய்',
    te: 'ఆర్డర్ చేయండి',
    kn: 'ಆರ್ಡರ್ ಮಾಡಿ',
    bn: 'অর্ডার করুন',
    pa: 'ਆਰਡਰ ਕਰੋ'
  },
  emptyCart: {
    en: 'Cart is empty',
    hi: 'कार्ट खाली है',
    mr: 'कार्ट रिकामी आहे',
    gu: 'કાર્ટ ખાલી છે',
    ta: 'கூடை காலியாக உள்ளது',
    te: 'కార్ట్ ఖాళీగా ఉంది',
    kn: 'ಕಾರ್ಟ್ ಖಾಲಿಯಾಗಿದೆ',
    bn: 'কার্ট খালি',
    pa: 'ਕਾਰਟ ਖਾਲੀ ਹੈ'
  },
  outOfStock: {
    en: 'Out of Stock',
    hi: 'स्टॉक में नहीं',
    mr: 'स्टॉक नाही',
    gu: 'સ્ટોકમાં નથી',
    ta: 'இருப்பில் இல்லை',
    te: 'స్టాక్ లేదు',
    kn: 'ಸ್ಟಾಕ್ ಇಲ್ಲ',
    bn: 'স্টকে নেই',
    pa: 'ਸਟਾਕ ਵਿੱਚ ਨਹੀਂ'
  },
  freeDelivery: {
    en: 'Free Delivery',
    hi: 'मुफ्त डिलीवरी',
    mr: 'मोफत डिलिव्हरी',
    gu: 'મફત ડિલિવરી',
    ta: 'இலவச டெலிவரி',
    te: 'ఉచిత డెలివరీ',
    kn: 'ಉಚಿತ ಡೆಲಿವರಿ',
    bn: 'বিনামূল্যে ডেলিভারি',
    pa: 'ਮੁਫ਼ਤ ਡਿਲਿਵਰੀ'
  },
  
  // ==================== CATEGORIES ====================
  all: {
    en: 'All',
    hi: 'सभी',
    mr: 'सर्व',
    gu: 'બધું',
    ta: 'அனைத்தும்',
    te: 'అన్నీ',
    kn: 'ಎಲ್ಲಾ',
    bn: 'সব',
    pa: 'ਸਾਰੇ'
  },
  electronics: {
    en: 'Electronics',
    hi: 'इलेक्ट्रॉनिक्स',
    mr: 'इलेक्ट्रॉनिक्स',
    gu: 'ઇલેક્ટ્રોનિક્સ',
    ta: 'எலக்ட்ரானிக்ஸ்',
    te: 'ఎలక్ట్రానిక్స్',
    kn: 'ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್',
    bn: 'ইলেকট্রনিক্স',
    pa: 'ਇਲੈਕਟ੍ਰਾਨਿਕਸ'
  },
  homeKitchen: {
    en: 'Home & Kitchen',
    hi: 'होम और किचन',
    mr: 'होम आणि किचन',
    gu: 'હોમ અને કિચન',
    ta: 'வீடு மற்றும் சமையலறை',
    te: 'హోమ్ & కిచెన్',
    kn: 'ಹೋಮ್ & ಕಿಚನ್',
    bn: 'হোম এবং কিচেন',
    pa: 'ਘਰ ਅਤੇ ਰਸੋਈ'
  },
  fashion: {
    en: 'Fashion',
    hi: 'फैशन',
    mr: 'फॅशन',
    gu: 'ફેશન',
    ta: 'ஃபேஷன்',
    te: 'ఫ్యాషన్',
    kn: 'ಫ್ಯಾಷನ್',
    bn: 'ফ্যাশন',
    pa: 'ਫੈਸ਼ਨ'
  },
  beauty: {
    en: 'Beauty',
    hi: 'ब्यूटी',
    mr: 'ब्युटी',
    gu: 'બ્યુટી',
    ta: 'அழகு',
    te: 'బ్యూటీ',
    kn: 'ಬ್ಯೂಟಿ',
    bn: 'বিউটি',
    pa: 'ਬਿਊਟੀ'
  },
  sports: {
    en: 'Sports',
    hi: 'स्पोर्ट्स',
    mr: 'स्पोर्ट्स',
    gu: 'સ્પોર્ટ્સ',
    ta: 'விளையாட்டு',
    te: 'స్పోర్ట్స్',
    kn: 'ಸ್ಪೋರ್ಟ್ಸ್',
    bn: 'স্পোর্টস',
    pa: 'ਸਪੋਰਟਸ'
  },
  
  // ==================== SUBSCRIPTION ====================
  subscription: {
    en: 'Subscription',
    hi: 'सदस्यता',
    mr: 'सदस्यता',
    gu: 'સબ્સ્ક્રિપ્શન',
    ta: 'சந்தா',
    te: 'సబ్‌స్క్రిప్షన్',
    kn: 'ಸಬ್‌ಸ್ಕ್ರಿಪ್ಷನ್',
    bn: 'সাবস্ক্রিপশন',
    pa: 'ਸਬਸਕ੍ਰਿਪਸ਼ਨ'
  },
  upgradeNow: {
    en: 'Upgrade Now',
    hi: 'अभी अपग्रेड करें',
    mr: 'आता अपग्रेड करा',
    gu: 'હમણાં અપગ્રેડ કરો',
    ta: 'இப்போது மேம்படுத்துங்கள்',
    te: 'ఇప్పుడు అప్‌గ్రేడ్ చేయండి',
    kn: 'ಈಗ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ',
    bn: 'এখনই আপগ্রেড করুন',
    pa: 'ਹੁਣੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ'
  },
  explorer: {
    en: 'Explorer',
    hi: 'एक्सप्लोरर',
    mr: 'एक्सप्लोरर',
    gu: 'એક્સપ્લોરર',
    ta: 'எக்ஸ்ப்ளோரர்',
    te: 'ఎక్స్‌ప్లోరర్',
    kn: 'ಎಕ್ಸ್‌ಪ್ಲೋರರ್',
    bn: 'এক্সপ্লোরার',
    pa: 'ਐਕਸਪਲੋਰਰ'
  },
  startup: {
    en: 'Startup',
    hi: 'स्टार्टअप',
    mr: 'स्टार्टअप',
    gu: 'સ્ટાર્ટઅપ',
    ta: 'ஸ்டார்ட்அப்',
    te: 'స్టార్టప్',
    kn: 'ಸ್ಟಾರ್ಟಪ್',
    bn: 'স্টার্টআপ',
    pa: 'ਸਟਾਰਟਅੱਪ'
  },
  growth: {
    en: 'Growth',
    hi: 'ग्रोथ',
    mr: 'ग्रोथ',
    gu: 'ગ્રોથ',
    ta: 'வளர்ச்சி',
    te: 'గ్రోత్',
    kn: 'ಗ್ರೋತ್',
    bn: 'গ্রোথ',
    pa: 'ਗ੍ਰੋਥ'
  },
  elite: {
    en: 'Elite',
    hi: 'एलीट',
    mr: 'एलीट',
    gu: 'એલીટ',
    ta: 'எலைட்',
    te: 'ఎలైట్',
    kn: 'ಎಲೈಟ್',
    bn: 'এলিট',
    pa: 'ਐਲੀਟ'
  },
  
  // ==================== KYC ====================
  kycVerification: {
    en: 'KYC Verification',
    hi: 'केवाईसी सत्यापन',
    mr: 'KYC पडताळणी',
    gu: 'KYC ચકાસણી',
    ta: 'KYC சரிபார்ப்பு',
    te: 'KYC ధృవీకరణ',
    kn: 'KYC ಪರಿಶೀಲನೆ',
    bn: 'KYC যাচাইকরণ',
    pa: 'KYC ਤਸਦੀਕ'
  },
  verifyIdentity: {
    en: 'Verify Your Identity',
    hi: 'अपनी पहचान सत्यापित करें',
    mr: 'तुमची ओळख पडताळा',
    gu: 'તમારી ઓળખ ચકાસો',
    ta: 'உங்கள் அடையாளத்தை சரிபார்க்கவும்',
    te: 'మీ గుర్తింపును ధృవీకరించండి',
    kn: 'ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಿ',
    bn: 'আপনার পরিচয় যাচাই করুন',
    pa: 'ਆਪਣੀ ਪਛਾਣ ਤਸਦੀਕ ਕਰੋ'
  },
  
  // ==================== BILLS & RECHARGE (DEPRECATED) ====================
  billPayments: {
    en: 'Services',
    hi: 'सेवाएं',
    mr: 'सेवा',
    gu: 'સેવાઓ',
    ta: 'சேவைகள்',
    te: 'సేవలు',
    kn: 'ಸೇವೆಗಳು',
    bn: 'সেবা',
    pa: 'ਸੇਵਾਵਾਂ'
  },
  mobileRecharge: {
    en: 'Mobile Recharge',
    hi: 'मोबाइल रिचार्ज',
    mr: 'मोबाइल रिचार्ज',
    gu: 'મોબાઇલ રિચાર્જ',
    ta: 'மொபைல் ரீசார்ஜ்',
    te: 'మొబైల్ రీచార్జ్',
    kn: 'ಮೊಬೈಲ್ ರೀಚಾರ್ಜ್',
    bn: 'মোবাইল রিচার্জ',
    pa: 'ਮੋਬਾਈਲ ਰੀਚਾਰਜ'
  },
  electricityBill: {
    en: 'Electricity Bill',
    hi: 'बिजली बिल',
    mr: 'वीज बिल',
    gu: 'વીજળી બિલ',
    ta: 'மின் கட்டணம்',
    te: 'విద్యుత్ బిల్',
    kn: 'ವಿದ್ಯುತ್ ಬಿಲ್',
    bn: 'বিদ্যুৎ বিল',
    pa: 'ਬਿਜਲੀ ਬਿੱਲ'
  },
  
  // ==================== GIFT VOUCHERS ====================
  giftVouchers: {
    en: 'Gift Vouchers',
    hi: 'गिफ्ट वाउचर',
    mr: 'गिफ्ट व्हाउचर्स',
    gu: 'ગિફ્ટ વાઉચર્સ',
    ta: 'பரிசு வவுச்சர்கள்',
    te: 'గిఫ్ట్ వౌచర్లు',
    kn: 'ಗಿಫ್ಟ್ ವೌಚರ್‌ಗಳು',
    bn: 'গিফট ভাউচার',
    pa: 'ਗਿਫ਼ਟ ਵਾਊਚਰ'
  },
  eVouchers: {
    en: 'E-Vouchers',
    hi: 'ई-वाउचर',
    mr: 'ई-व्हाउचर्स',
    gu: 'ઈ-વાઉચર્સ',
    ta: 'ஈ-வவுச்சர்கள்',
    te: 'ఈ-వౌచర్లు',
    kn: 'ಇ-ವೌಚರ್‌ಗಳು',
    bn: 'ই-ভাউচার',
    pa: 'ਈ-ਵਾਊਚਰ'
  },
  rechargeBills: {
    en: 'Recharge & Bills',
    hi: 'रिचार्ज और बिल',
    mr: 'रिचार्ज आणि बिल',
    gu: 'રિચાર્જ અને બિલ',
    ta: 'ரீசார்ஜ் & பில்கள்',
    te: 'రీచార్జ్ & బిల్లులు',
    kn: 'ರೀಚಾರ್ಜ್ & ಬಿಲ್‌ಗಳು',
    bn: 'রিচার্জ ও বিল',
    pa: 'ਰੀਚਾਰਜ ਅਤੇ ਬਿੱਲ'
  },
  
  // ==================== LANGUAGE ====================
  language: {
    en: 'Language',
    hi: 'भाषा',
    mr: 'भाषा',
    gu: 'ભાષા',
    ta: 'மொழி',
    te: 'భాష',
    kn: 'ಭಾಷೆ',
    bn: 'ভাষা',
    pa: 'ਭਾਸ਼ਾ'
  },
  selectLanguage: {
    en: 'Select Language',
    hi: 'भाषा चुनें',
    mr: 'भाषा निवडा',
    gu: 'ભાષા પસંદ કરો',
    ta: 'மொழியைத் தேர்ந்தெடுங்கள்',
    te: 'భాషను ఎంచుకోండి',
    kn: 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    bn: 'ভাষা নির্বাচন করুন',
    pa: 'ਭਾਸ਼ਾ ਚੁਣੋ'
  },
  
  // ==================== BUTTONS ====================
  save: {
    en: 'Save',
    hi: 'सेव करें',
    mr: 'सेव्ह करा',
    gu: 'સેવ કરો',
    ta: 'சேமி',
    te: 'సేవ్ చేయండి',
    kn: 'ಉಳಿಸಿ',
    bn: 'সেভ করুন',
    pa: 'ਸੇਵ ਕਰੋ'
  },
  cancel: {
    en: 'Cancel',
    hi: 'रद्द करें',
    mr: 'रद्द करा',
    gu: 'રદ કરો',
    ta: 'ரத்து செய்',
    te: 'రద్దు చేయండి',
    kn: 'ರದ್ದುಮಾಡಿ',
    bn: 'বাতিল করুন',
    pa: 'ਰੱਦ ਕਰੋ'
  },
  submit: {
    en: 'Submit',
    hi: 'जमा करें',
    mr: 'सबमिट करा',
    gu: 'સબમિટ કરો',
    ta: 'சமர்ப்பி',
    te: 'సబ్మిట్ చేయండి',
    kn: 'ಸಲ್ಲಿಸಿ',
    bn: 'জমা দিন',
    pa: 'ਜਮ੍ਹਾਂ ਕਰੋ'
  },
  back: {
    en: 'Back',
    hi: 'वापस',
    mr: 'मागे',
    gu: 'પાછા',
    ta: 'பின்',
    te: 'వెనుకకు',
    kn: 'ಹಿಂದೆ',
    bn: 'পিছনে',
    pa: 'ਪਿੱਛੇ'
  },
  next: {
    en: 'Next',
    hi: 'आगे',
    mr: 'पुढे',
    gu: 'આગળ',
    ta: 'அடுத்து',
    te: 'తదుపరి',
    kn: 'ಮುಂದೆ',
    bn: 'পরবর্তী',
    pa: 'ਅੱਗੇ'
  },
  viewAll: {
    en: 'View All',
    hi: 'सभी देखें',
    mr: 'सर्व पहा',
    gu: 'બધું જુઓ',
    ta: 'அனைத்தையும் காண்க',
    te: 'అన్నీ చూడండి',
    kn: 'ಎಲ್ಲಾ ವೀಕ್ಷಿಸಿ',
    bn: 'সব দেখুন',
    pa: 'ਸਭ ਦੇਖੋ'
  },
  
  // ==================== DASHBOARD SPECIFIC ====================
  services: {
    en: 'Services',
    hi: 'सेवाएं',
    mr: 'सेवा',
    gu: 'સેવાઓ',
    ta: 'சேவைகள்',
    te: 'సేవలు',
    kn: 'ಸೇವೆಗಳು',
    bn: 'সেবা',
    pa: 'ਸੇਵਾਵਾਂ'
  },
  // NOTE: Removed duplicate definitions of billPayments / giftVouchers /
  // upgradeNow that previously lived here. They redefined keys already
  // declared higher in the file, causing the linter to fail and silently
  // overriding earlier translations.
  unlockRedeemServices: {
    en: 'Unlock Redeem Services',
    hi: 'रिडीम सेवाएं अनलॉक करें',
    mr: 'रिडीम सेवा अनलॉक करा',
    gu: 'રિડીમ સેવાઓ અનલૉક કરો',
    ta: 'ரிடீம் சேவைகளை திறக்கவும்',
    te: 'రీడీమ్ సేవలను అన్‌లాక్ చేయండి',
    kn: 'ರಿಡೀಮ್ ಸೇವೆಗಳನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಿ',
    bn: 'রিডিম সেবা আনলক করুন',
    pa: 'ਰੀਡੀਮ ਸੇਵਾਵਾਂ ਅਨਲੌਕ ਕਰੋ'
  },
  // Note: Using 'referrals' key for backward compatibility but showing "Invite Friends"
  mobile: {
    en: 'Mobile',
    hi: 'मोबाइल',
    mr: 'मोबाइल',
    gu: 'મોબાઇલ',
    ta: 'மொபைல்',
    te: 'మొబైల్',
    kn: 'ಮೊಬೈಲ್',
    bn: 'মোবাইল',
    pa: 'ਮੋਬਾਈਲ'
  },
  dth: {
    en: 'DTH',
    hi: 'DTH',
    mr: 'DTH',
    gu: 'DTH',
    ta: 'DTH',
    te: 'DTH',
    kn: 'DTH',
    bn: 'DTH',
    pa: 'DTH'
  },
  electricity: {
    en: 'Electric',
    hi: 'बिजली',
    mr: 'वीज',
    gu: 'વીજળી',
    ta: 'மின்சாரம்',
    te: 'విద్యుత్',
    kn: 'ವಿದ್ಯುತ್',
    bn: 'বিদ্যুৎ',
    pa: 'ਬਿਜਲੀ'
  },
  gas: {
    en: 'Gas',
    hi: 'गैस',
    mr: 'गॅस',
    gu: 'ગેસ',
    ta: 'எரிவாயு',
    te: 'గ్యాస్',
    kn: 'ಗ್ಯಾಸ್',
    bn: 'গ্যাস',
    pa: 'ਗੈਸ'
  },
  loanEmi: {
    en: 'Loan EMI',
    hi: 'लोन EMI',
    mr: 'लोन EMI',
    gu: 'લોન EMI',
    ta: 'கடன் EMI',
    te: 'లోన్ EMI',
    kn: 'ಲೋನ್ EMI',
    bn: 'লোন EMI',
    pa: 'ਲੋਨ EMI'
  },
  recentTransactions: {
    en: 'Recent Transactions',
    hi: 'हाल के लेनदेन',
    mr: 'अलीकडील व्यवहार',
    gu: 'તાજેતરના વ્યવહારો',
    ta: 'சமீபத்திய பரிவர்த்தனைகள்',
    te: 'ఇటీవలి లావాదేవీలు',
    kn: 'ಇತ್ತೀಚಿನ ವಹಿವಾಟುಗಳು',
    bn: 'সাম্প্রতিক লেনদেন',
    pa: 'ਹਾਲੀਆ ਲੈਣ-ਦੇਣ'
  },
  noTransactions: {
    en: 'No transactions yet',
    hi: 'अभी तक कोई लेनदेन नहीं',
    mr: 'अजून कोणतेही व्यवहार नाहीत',
    gu: 'હજુ સુધી કોઈ વ્યવહાર નથી',
    ta: 'இன்னும் பரிவர்த்தனைகள் இல்லை',
    te: 'ఇంకా లావాదేవీలు లేవు',
    kn: 'ಇನ್ನೂ ವಹಿವಾಟುಗಳಿಲ್ಲ',
    bn: 'এখনও কোনো লেনদেন নেই',
    pa: 'ਅਜੇ ਕੋਈ ਲੈਣ-ਦੇਣ ਨਹੀਂ'
  },
  
  loadMore: {
    en: 'Load More',
    hi: 'और लोड करें',
    mr: 'अजून लोड करा',
    gu: 'વધુ લોડ કરો',
    ta: 'மேலும் ஏற்றுக',
    te: 'మరింత లోడ్ చేయండి',
    kn: 'ಹೆಚ್ಚು ಲೋಡ್ ಮಾಡಿ',
    bn: 'আরও লোড করুন',
    pa: 'ਹੋਰ ਲੋਡ ਕਰੋ'
  },
  
  // ==================== STATUS ====================
  loading: {
    en: 'Loading...',
    hi: 'लोड हो रहा है...',
    mr: 'लोड होत आहे...',
    gu: 'લોડ થઈ રહ્યું છે...',
    ta: 'ஏற்றுகிறது...',
    te: 'లోడ్ అవుతోంది...',
    kn: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    bn: 'লোড হচ্ছে...',
    pa: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...'
  },
  success: {
    en: 'Success',
    hi: 'सफलता',
    mr: 'यशस्वी',
    gu: 'સફળતા',
    ta: 'வெற்றி',
    te: 'విజయం',
    kn: 'ಯಶಸ್ಸು',
    bn: 'সাফল্য',
    pa: 'ਸਫਲਤਾ'
  },
  error: {
    en: 'Error',
    hi: 'त्रुटि',
    mr: 'त्रुटी',
    gu: 'ભૂલ',
    ta: 'பிழை',
    te: 'లోపం',
    kn: 'ದೋಷ',
    bn: 'ত্রুটি',
    pa: 'ਗਲਤੀ'
  },
  retry: {
    en: 'Retry',
    hi: 'पुनः प्रयास करें',
    mr: 'पुन्हा प्रयत्न करा',
    gu: 'ફરી પ્રયાસ કરો',
    ta: 'மீண்டும் முயற்சிக்கவும்',
    te: 'మళ్ళీ ప్రయత్నించండి',
    kn: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
    bn: 'আবার চেষ্টা করুন',
    pa: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ'
  },
  
  // ==================== AUTH ====================
  login: {
    en: 'Login',
    hi: 'लॉगिन',
    mr: 'लॉगिन',
    gu: 'લૉગિન',
    ta: 'உள்நுழை',
    te: 'లాగిన్',
    kn: 'ಲಾಗಿನ್',
    bn: 'লগইন',
    pa: 'ਲੌਗਇਨ'
  },
  logout: {
    en: 'Logout',
    hi: 'लॉगआउट',
    mr: 'लॉगआउट',
    gu: 'લૉગઆઉટ',
    ta: 'வெளியேறு',
    te: 'లాగ్‌అవుట్',
    kn: 'ಲಾಗ್‌ಔಟ್',
    bn: 'লগআউট',
    pa: 'ਲੌਗਆਉਟ'
  },
  register: {
    en: 'Register',
    hi: 'रजिस्टर करें',
    mr: 'नोंदणी करा',
    gu: 'નોંધણી કરો',
    ta: 'பதிவு செய்',
    te: 'నమోదు చేయండి',
    kn: 'ನೋಂದಾಯಿಸಿ',
    bn: 'নিবন্ধন করুন',
    pa: 'ਰਜਿਸਟਰ ਕਰੋ'
  },
  
  // ==================== MISC ====================
  noDataFound: {
    en: 'No data found',
    hi: 'कोई डेटा नहीं मिला',
    mr: 'डेटा आढळला नाही',
    gu: 'કોઈ ડેટા મળ્યો નથી',
    ta: 'தரவு இல்லை',
    te: 'డేటా కనుగొనబడలేదు',
    kn: 'ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ',
    bn: 'কোনো ডেটা পাওয়া যায়নি',
    pa: 'ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ'
  },
  comingSoon: {
    en: 'Coming Soon',
    hi: 'जल्द आ रहा है',
    mr: 'लवकरच येत आहे',
    gu: 'ટૂંક સમયમાં આવશે',
    ta: 'விரைவில் வருகிறது',
    te: 'త్వరలో వస్తోంది',
    kn: 'ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ',
    bn: 'শীঘ্রই আসছে',
    pa: 'ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ'
  },
  today: {
    en: 'Today',
    hi: 'आज',
    mr: 'आज',
    gu: 'આજે',
    ta: 'இன்று',
    te: 'ఈరోజు',
    kn: 'ಇಂದು',
    bn: 'আজ',
    pa: 'ਅੱਜ'
  },
  total: {
    en: 'Total',
    hi: 'कुल',
    mr: 'एकूण',
    gu: 'કુલ',
    ta: 'மொத்தம்',
    te: 'మొత్తం',
    kn: 'ಒಟ್ಟು',
    bn: 'মোট',
    pa: 'ਕੁੱਲ'
  },

  // ==================== DASHBOARD CARDS ====================
  yourStats: {
    en: 'Your Stats',
    hi: 'आपके आंकड़े',
    mr: 'तुमची आकडेवारी',
    gu: 'તમારા આંકડા',
    ta: 'உங்கள் புள்ளிவிவரங்கள்',
    te: 'మీ గణాంకాలు',
    kn: 'ನಿಮ್ಮ ಅಂಕಿಅಂಶಗಳು',
    bn: 'আপনার পরিসংখ্যান',
    pa: 'ਤੁਹਾਡੇ ਅੰਕੜੇ'
  },
  recentActivity: {
    en: 'Recent Activity',
    hi: 'हाल की गतिविधि',
    mr: 'अलीकडील क्रिया',
    gu: 'તાજેતરની પ્રવૃત્તિ',
    ta: 'சமீபத்திய செயல்பாடு',
    te: 'ఇటీవలి కార్యకలాపం',
    kn: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ',
    bn: 'সাম্প্রতিক কার্যকলাপ',
    pa: 'ਤਾਜ਼ਾ ਗਤੀਵਿਧੀ'
  },
  inviteFriends: {
    en: 'Invite Friends',
    hi: 'दोस्तों को आमंत्रित करें',
    mr: 'मित्रांना आमंत्रित करा',
    gu: 'મિત્રોને આમંત્રિત કરો',
    ta: 'நண்பர்களை அழைக்கவும்',
    te: 'స్నేహితులను ఆహ్వానించండి',
    kn: 'ಸ್ನೇಹಿತರನ್ನು ಆಹ್ವಾನಿಸಿ',
    bn: 'বন্ধুদের আমন্ত্রণ জানান',
    pa: 'ਦੋਸਤਾਂ ਨੂੰ ਸੱਦੋ'
  },
  shareAndEarn: {
    en: 'Share & Earn',
    hi: 'शेयर करें और कमाएं',
    mr: 'शेअर करा आणि कमवा',
    gu: 'શેર કરો અને કમાઓ',
    ta: 'பகிர்ந்து சம்பாதியுங்கள்',
    te: 'షేర్ చేసి సంపాదించండి',
    kn: 'ಹಂಚಿಕೊಳ್ಳಿ ಮತ್ತು ಗಳಿಸಿ',
    bn: 'শেয়ার করুন ও আয় করুন',
    pa: 'ਸਾਂਝਾ ਕਰੋ ਤੇ ਕਮਾਓ'
  },
  copyReferralCode: {
    en: 'Copy Invite Code',
    hi: 'रेफरल कोड कॉपी करें',
    mr: 'इनव्हाइट कोड कॉपी करा',
    gu: 'ઇન્વાઇટ કોડ કૉપી કરો',
    ta: 'அழைப்பு குறியீட்டை நகலெடுக்கவும்',
    te: 'ఇన్వైట్ కోడ్ కాపీ చేయండి',
    kn: 'ಇನ್ವೈಟ್ ಕೋಡ್ ನಕಲಿಸಿ',
    bn: 'ইনভাইট কোড কপি করুন',
    pa: 'ਇਨਵਾਈਟ ਕੋਡ ਕਾਪੀ ਕਰੋ'
  },

  // ==================== INVITE FRIENDS (formerly Tap Game section removed) ====================
  // The dead `inviteFriends` entry here (which contained "Tap to Earn PRC"
  // translations from the removed Tap Game feature) was overriding the
  // correct definition earlier in the file. Removed to silence lint and
  // restore proper "Invite Friends" UI labels.
  dailyTaps: {
    en: 'Daily Taps',
    hi: 'दैनिक टैप',
    mr: 'दैनिक टॅप',
    gu: 'દૈનિક ટેપ',
    ta: 'தினசரி தட்டல்கள்',
    te: 'రోజువారీ ట్యాప్‌లు',
    kn: 'ದೈನಿಕ ಟ್ಯಾಪ್‌ಗಳು',
    bn: 'দৈনিক ট্যাপ',
    pa: 'ਰੋਜ਼ਾਨਾ ਟੈਪ'
  },
  tapsRemaining: {
    en: 'Taps Remaining',
    hi: 'शेष टैप',
    mr: 'उरलेले टॅप',
    gu: 'બાકી ટેપ',
    ta: 'மீதமுள்ள தட்டல்கள்',
    te: 'మిగిలిన ట్యాప్‌లు',
    kn: 'ಉಳಿದ ಟ್ಯಾಪ್‌ಗಳು',
    bn: 'বাকি ট্যাপ',
    pa: 'ਬਾਕੀ ਟੈਪ'
  },

  // ==================== NETWORK / SOCIAL ====================
  followers: {
    en: 'Followers',
    hi: 'फॉलोअर्स',
    mr: 'फॉलोअर्स',
    gu: 'ફોલોઅર્સ',
    ta: 'பின்தொடர்பவர்கள்',
    te: 'ఫాలోవర్లు',
    kn: 'ಅನುಯಾಯಿಗಳು',
    bn: 'অনুসরণকারী',
    pa: 'ਫਾਲੋਅਰ'
  },
  following: {
    en: 'Following',
    hi: 'फॉलोइंग',
    mr: 'फॉलोइंग',
    gu: 'ફોલોઇંગ',
    ta: 'பின்தொடர்கிறது',
    te: 'ఫాలో చేస్తున్నారు',
    kn: 'ಅನುಸರಿಸುತ್ತಿದೆ',
    bn: 'অনুসরণ করছেন',
    pa: 'ਫਾਲੋ ਕਰ ਰਹੇ ਹੋ'
  },
  follow: {
    en: 'Follow',
    hi: 'फॉलो करें',
    mr: 'फॉलो करा',
    gu: 'ફોલો કરો',
    ta: 'பின்தொடரவும்',
    te: 'ఫాలో చేయండి',
    kn: 'ಅನುಸರಿಸಿ',
    bn: 'অনুসরণ করুন',
    pa: 'ਫਾਲੋ ਕਰੋ'
  },
  unfollow: {
    en: 'Unfollow',
    hi: 'अनफॉलो करें',
    mr: 'अनफॉलो करा',
    gu: 'અનફોલો કરો',
    ta: 'பின்தொடர்வதை நிறுத்து',
    te: 'అన్‌ఫాలో చేయండి',
    kn: 'ಅನುಸರಿಸುವುದನ್ನು ನಿಲ್ಲಿಸಿ',
    bn: 'আনফলো করুন',
    pa: 'ਅਨਫਾਲੋ ਕਰੋ'
  },
  discoverConnect: {
    en: 'Discover & Connect',
    hi: 'खोजें और जुड़ें',
    mr: 'शोधा आणि जोडा',
    gu: 'શોધો અને જોડાઓ',
    ta: 'கண்டறிந்து இணையுங்கள்',
    te: 'కనుగొని కనెక్ట్ అవ్వండి',
    kn: 'ಅನ್ವೇಷಿಸಿ ಮತ್ತು ಸಂಪರ್ಕಿಸಿ',
    bn: 'আবিষ্কার করুন এবং সংযুক্ত হন',
    pa: 'ਖੋਜੋ ਅਤੇ ਜੁੜੋ'
  },
  conversations: {
    en: 'Conversations',
    hi: 'बातचीत',
    mr: 'संवाद',
    gu: 'વાર્તાલાપ',
    ta: 'உரையாடல்கள்',
    te: 'సంభాషణలు',
    kn: 'ಸಂಭಾಷಣೆಗಳು',
    bn: 'কথোপকথন',
    pa: 'ਗੱਲਬਾਤ'
  },
  sendMessage: {
    en: 'Send Message',
    hi: 'संदेश भेजें',
    mr: 'संदेश पाठवा',
    gu: 'સંદેશ મોકલો',
    ta: 'செய்தி அனுப்பு',
    te: 'సందేశం పంపండి',
    kn: 'ಸಂದೇಶ ಕಳುಹಿಸಿ',
    bn: 'বার্তা পাঠান',
    pa: 'ਸੁਨੇਹਾ ਭੇਜੋ'
  },
  typeMessage: {
    en: 'Type a message...',
    hi: 'संदेश लिखें...',
    mr: 'संदेश टाइप करा...',
    gu: 'સંદેશ લખો...',
    ta: 'செய்தியை உள்ளிடவும்...',
    te: 'సందేశాన్ని టైప్ చేయండి...',
    kn: 'ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...',
    bn: 'বার্তা লিখুন...',
    pa: 'ਸੁਨੇਹਾ ਲਿਖੋ...'
  },
  noMessages: {
    en: 'No messages yet',
    hi: 'अभी कोई संदेश नहीं',
    mr: 'अजून कोणतेही संदेश नाहीत',
    gu: 'હજુ કોઈ સંદેશ નથી',
    ta: 'இன்னும் செய்திகள் இல்லை',
    te: 'ఇంకా సందేశాలు లేవు',
    kn: 'ಇನ್ನೂ ಸಂದೇಶಗಳಿಲ್ಲ',
    bn: 'এখনও কোনো বার্তা নেই',
    pa: 'ਅਜੇ ਕੋਈ ਸੁਨੇਹਾ ਨਹੀਂ'
  },

  // ==================== NOTIFICATIONS ====================
  allCaughtUp: {
    en: 'All caught up!',
    hi: 'सब पढ़ लिया!',
    mr: 'सर्व वाचले!',
    gu: 'બધું વાંચ્યું!',
    ta: 'எல்லாம் படித்தாயிற்று!',
    te: 'అన్నీ చదివారు!',
    kn: 'ಎಲ್ಲಾ ಓದಿದ್ದೀರಿ!',
    bn: 'সব পড়া হয়ে গেছে!',
    pa: 'ਸਭ ਪੜ੍ਹ ਲਿਆ!'
  },
  unread: {
    en: 'unread',
    hi: 'अपठित',
    mr: 'न वाचलेले',
    gu: 'વાંચ્યું નથી',
    ta: 'படிக்கவில்லை',
    te: 'చదవలేదు',
    kn: 'ಓದಿಲ್ಲ',
    bn: 'অপঠিত',
    pa: 'ਨਹੀਂ ਪੜ੍ਹਿਆ'
  },
  markAllRead: {
    en: 'Mark All Read',
    hi: 'सभी को पढ़ा हुआ चिह्नित करें',
    mr: 'सर्व वाचले म्हणून चिन्हांकित करा',
    gu: 'બધાને વાંચેલું તરીકે ચિહ્નિત કરો',
    ta: 'அனைத்தையும் படித்ததாக குறிக்கவும்',
    te: 'అన్నింటిని చదివినట్లు గుర్తించండి',
    kn: 'ಎಲ್ಲವನ್ನೂ ಓದಿದಂತೆ ಗುರುತಿಸಿ',
    bn: 'সব পড়া হয়েছে বলে চিহ্নিত করুন',
    pa: 'ਸਾਰੇ ਪੜ੍ਹੇ ਵਜੋਂ ਮਾਰਕ ਕਰੋ'
  },

  // ==================== SUBSCRIPTION PLANS ====================
  choosePlan: {
    en: 'Choose Your Plan',
    hi: 'अपना प्लान चुनें',
    mr: 'तुमचा प्लॅन निवडा',
    gu: 'તમારો પ્લાન પસંદ કરો',
    ta: 'உங்கள் திட்டத்தைத் தேர்ந்தெடுக்கவும்',
    te: 'మీ ప్లాన్ ఎంచుకోండి',
    kn: 'ನಿಮ್ಮ ಪ್ಲಾನ್ ಆಯ್ಕೆಮಾಡಿ',
    bn: 'আপনার প্ল্যান বেছে নিন',
    pa: 'ਆਪਣਾ ਪਲਾਨ ਚੁਣੋ'
  },
  currentPlan: {
    en: 'Current Plan',
    hi: 'वर्तमान प्लान',
    mr: 'सध्याचा प्लॅन',
    gu: 'વર્તમાન પ્લાન',
    ta: 'தற்போதைய திட்டம்',
    te: 'ప్రస్తుత ప్లాన్',
    kn: 'ಪ್ರಸ್ತುತ ಪ್ಲಾನ್',
    bn: 'বর্তমান প্ল্যান',
    pa: 'ਮੌਜੂਦਾ ਪਲਾਨ'
  },
  perMonth: {
    en: '/month',
    hi: '/महीना',
    mr: '/महिना',
    gu: '/મહિનો',
    ta: '/மாதம்',
    te: '/నెల',
    kn: '/ತಿಂಗಳು',
    bn: '/মাস',
    pa: '/ਮਹੀਨਾ'
  },
  free: {
    en: 'Free',
    hi: 'मुफ्त',
    mr: 'मोफत',
    gu: 'મફત',
    ta: 'இலவசம்',
    te: 'ఉచితం',
    kn: 'ಉಚಿತ',
    bn: 'বিনামূল্যে',
    pa: 'ਮੁਫ਼ਤ'
  },
  selectPlan: {
    en: 'Select Plan',
    hi: 'प्लान चुनें',
    mr: 'प्लॅन निवडा',
    gu: 'પ્લાન પસંદ કરો',
    ta: 'திட்டத்தைத் தேர்ந்தெடு',
    te: 'ప్లాన్ ఎంచుకోండి',
    kn: 'ಪ್ಲಾನ್ ಆಯ್ಕೆಮಾಡಿ',
    bn: 'প্ল্যান নির্বাচন করুন',
    pa: 'ਪਲਾਨ ਚੁਣੋ'
  },

  // ==================== REFERRAL ====================
  yourReferralCode: {
    en: 'Your Invite Code',
    hi: 'आपका रेफरल कोड',
    mr: 'तुमचा रेफरल कोड',
    gu: 'તમારો રેફરલ કોડ',
    ta: 'உங்கள் பரிந்துரை குறியீடு',
    te: 'మీ రెఫరల్ కోడ్',
    kn: 'ನಿಮ್ಮ ರೆಫರಲ್ ಕೋಡ್',
    bn: 'আপনার রেফারেল কোড',
    pa: 'ਤੁਹਾਡਾ ਰੈਫਰਲ ਕੋਡ'
  },
  totalReferrals: {
    en: 'Friends Invited',
    hi: 'कुल रेफरल',
    mr: 'एकूण रेफरल्स',
    gu: 'કુલ રેફરલ્સ',
    ta: 'மொத்த பரிந்துரைகள்',
    te: 'మొత్తం రెఫరల్స్',
    kn: 'ಒಟ್ಟು ರೆಫರಲ್‌ಗಳು',
    bn: 'মোট রেফারেল',
    pa: 'ਕੁੱਲ ਰੈਫਰਲ'
  },
  referralEarnings: {
    en: 'Mining Boost',
    hi: 'रेफरल कमाई',
    mr: 'रेफरल कमाई',
    gu: 'રેફરલ કમાણી',
    ta: 'பரிந்துரை வருமானம்',
    te: 'రెఫరల్ ఆదాయం',
    kn: 'ರೆಫರಲ್ ಗಳಿಕೆ',
    bn: 'রেফারেল আয়',
    pa: 'ਰੈਫਰਲ ਕਮਾਈ'
  },
  shareNow: {
    en: 'Share Now',
    hi: 'अभी शेयर करें',
    mr: 'आता शेअर करा',
    gu: 'હમણાં શેર કરો',
    ta: 'இப்போது பகிரவும்',
    te: 'ఇప్పుడు షేర్ చేయండి',
    kn: 'ಈಗ ಹಂಚಿಕೊಳ್ಳಿ',
    bn: 'এখনই শেয়ার করুন',
    pa: 'ਹੁਣੇ ਸਾਂਝਾ ਕਰੋ'
  },

  // ==================== FORM LABELS ====================
  phoneNumber: {
    en: 'Phone Number',
    hi: 'फोन नंबर',
    mr: 'फोन नंबर',
    gu: 'ફોન નંબર',
    ta: 'தொலைபேசி எண்',
    te: 'ఫోన్ నంబర్',
    kn: 'ಫೋನ್ ನಂಬರ್',
    bn: 'ফোন নম্বর',
    pa: 'ਫ਼ੋਨ ਨੰਬਰ'
  },
  email: {
    en: 'Email',
    hi: 'ईमेल',
    mr: 'ईमेल',
    gu: 'ઈમેલ',
    ta: 'மின்னஞ்சல்',
    te: 'ఇమెయిల్',
    kn: 'ಇಮೇಲ್',
    bn: 'ইমেইল',
    pa: 'ਈਮੇਲ'
  },
  password: {
    en: 'Password',
    hi: 'पासवर्ड',
    mr: 'पासवर्ड',
    gu: 'પાસવર્ડ',
    ta: 'கடவுச்சொல்',
    te: 'పాస్‌వర్డ్',
    kn: 'ಪಾಸ್‌ವರ್ಡ್',
    bn: 'পাসওয়ার্ড',
    pa: 'ਪਾਸਵਰਡ'
  },
  name: {
    en: 'Name',
    hi: 'नाम',
    mr: 'नाव',
    gu: 'નામ',
    ta: 'பெயர்',
    te: 'పేరు',
    kn: 'ಹೆಸರು',
    bn: 'নাম',
    pa: 'ਨਾਮ'
  },
  amount: {
    en: 'Amount',
    hi: 'राशि',
    mr: 'रक्कम',
    gu: 'રકમ',
    ta: 'தொகை',
    te: 'మొత్తం',
    kn: 'ಮೊತ್ತ',
    bn: 'পরিমাণ',
    pa: 'ਰਕਮ'
  },
  operator: {
    en: 'Operator',
    hi: 'ऑपरेटर',
    mr: 'ऑपरेटर',
    gu: 'ઓપરેટર',
    ta: 'ஆபரேட்டர்',
    te: 'ఆపరేటర్',
    kn: 'ಆಪರೇಟರ್',
    bn: 'অপারেটর',
    pa: 'ਆਪਰੇਟਰ'
  },

  // ==================== HISTORY ====================
  history: {
    en: 'History',
    hi: 'इतिहास',
    mr: 'इतिहास',
    gu: 'ઇતિહાસ',
    ta: 'வரலாறு',
    te: 'చరిత్ర',
    kn: 'ಇತಿಹಾಸ',
    bn: 'ইতিহাস',
    pa: 'ਇਤਿਹਾਸ'
  },
  transactionHistory: {
    en: 'Transaction History',
    hi: 'लेनदेन इतिहास',
    mr: 'व्यवहार इतिहास',
    gu: 'વ્યવહાર ઇતિહાસ',
    ta: 'பரிவர்த்தனை வரலாறு',
    te: 'లావాదేవీల చరిత్ర',
    kn: 'ವಹಿವಾಟು ಇತಿಹಾಸ',
    bn: 'লেনদেনের ইতিহাস',
    pa: 'ਲੈਣ-ਦੇਣ ਇਤਿਹਾਸ'
  },
  pending: {
    en: 'Pending',
    hi: 'लंबित',
    mr: 'प्रलंबित',
    gu: 'બાકી',
    ta: 'நிலுவையில்',
    te: 'పెండింగ్',
    kn: 'ಬಾಕಿ ಇದೆ',
    bn: 'মুলতুবি',
    pa: 'ਬਕਾਇਆ'
  },
  completed: {
    en: 'Completed',
    hi: 'पूर्ण',
    mr: 'पूर्ण',
    gu: 'પૂર્ણ',
    ta: 'முடிந்தது',
    te: 'పూర్తయింది',
    kn: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
    bn: 'সম্পন্ন',
    pa: 'ਮੁਕੰਮਲ'
  },
  failed: {
    en: 'Failed',
    hi: 'विफल',
    mr: 'अयशस्वी',
    gu: 'નિષ્ફળ',
    ta: 'தோல்வி',
    te: 'విఫలమైంది',
    kn: 'ವಿಫಲವಾಗಿದೆ',
    bn: 'ব্যর্থ',
    pa: 'ਅਸਫਲ'
  },

  // ==================== PAYMENT ====================
  payNow: {
    en: 'Pay Now',
    hi: 'अभी भुगतान करें',
    mr: 'आता पैसे भरा',
    gu: 'હમણાં ચૂકવો',
    ta: 'இப்போது செலுத்துங்கள்',
    te: 'ఇప్పుడు చెల్లించండి',
    kn: 'ಈಗ ಪಾವತಿಸಿ',
    bn: 'এখনই পেমেন্ট করুন',
    pa: 'ਹੁਣੇ ਭੁਗਤਾਨ ਕਰੋ'
  },
  payUsing: {
    en: 'Pay Using',
    hi: 'इससे भुगतान करें',
    mr: 'याद्वारे पैसे भरा',
    gu: 'આનાથી ચૂકવો',
    ta: 'இதைப் பயன்படுத்தி செலுத்துங்கள்',
    te: 'దీని ద్వారా చెల్లించండి',
    kn: 'ಇದನ್ನು ಬಳಸಿ ಪಾವತಿಸಿ',
    bn: 'এটি ব্যবহার করে পেমেন্ট করুন',
    pa: 'ਇਸ ਨਾਲ ਭੁਗਤਾਨ ਕਰੋ'
  },
  insufficientBalance: {
    en: 'Insufficient Balance',
    hi: 'अपर्याप्त शेष',
    mr: 'अपुरी शिल्लक',
    gu: 'અપૂરતું બેલેન્સ',
    ta: 'போதுமான இருப்பு இல்லை',
    te: 'సరిపోని బ్యాలెన్స్',
    kn: 'ಅಸಮರ್ಪಕ ಬ್ಯಾಲೆನ್ಸ್',
    bn: 'অপর্যাপ্ত ব্যালেন্স',
    pa: 'ਨਾਕਾਫ਼ੀ ਬੈਲੇਂਸ'
  },

  // ==================== PROFILE ====================
  editProfile: {
    en: 'Edit Profile',
    hi: 'प्रोफ़ाइल संपादित करें',
    mr: 'प्रोफाइल संपादित करा',
    gu: 'પ્રોફાઇલ સંપાદિત કરો',
    ta: 'சுயவிவரத்தைத் திருத்து',
    te: 'ప్రొఫైల్ సవరించండి',
    kn: 'ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ',
    bn: 'প্রোফাইল সম্পাদনা করুন',
    pa: 'ਪ੍ਰੋਫਾਈਲ ਸੋਧੋ'
  },
  changePassword: {
    en: 'Change Password',
    hi: 'पासवर्ड बदलें',
    mr: 'पासवर्ड बदला',
    gu: 'પાસવર્ડ બદલો',
    ta: 'கடவுச்சொல்லை மாற்று',
    te: 'పాస్‌వర్డ్ మార్చండి',
    kn: 'ಪಾಸ್‌ವರ್ಡ್ ಬದಲಿಸಿ',
    bn: 'পাসওয়ার্ড পরিবর্তন করুন',
    pa: 'ਪਾਸਵਰਡ ਬਦਲੋ'
  },
  personalInfo: {
    en: 'Personal Information',
    hi: 'व्यक्तिगत जानकारी',
    mr: 'वैयक्तिक माहिती',
    gu: 'વ્યક્તિગત માહિતી',
    ta: 'தனிப்பட்ட தகவல்',
    te: 'వ్యక్తిగత సమాచారం',
    kn: 'ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ',
    bn: 'ব্যক্তিগত তথ্য',
    pa: 'ਨਿੱਜੀ ਜਾਣਕਾਰੀ'
  },
  security: {
    en: 'Security',
    hi: 'सुरक्षा',
    mr: 'सुरक्षा',
    gu: 'સુરક્ષા',
    ta: 'பாதுகாப்பு',
    te: 'భద్రత',
    kn: 'ಭದ್ರತೆ',
    bn: 'নিরাপত্তা',
    pa: 'ਸੁਰੱਖਿਆ'
  },

  // ==================== DASHBOARD ====================
  welcomeBack: {
    en: 'Welcome back,',
    hi: 'वापस स्वागत है,',
    mr: 'पुन्हा स्वागत,',
    gu: 'પાછા આવ્યા છો,',
    ta: 'மீண்டும் வரவேற்கிறோம்,',
    te: 'తిరిగి స్వాగతం,',
    kn: 'ಮತ್ತೆ ಸ್ವಾಗತ,',
    bn: 'ফিরে স্বাগতম,',
    pa: 'ਫਿਰ ਜੀ ਆਇਆ ਨੂੰ,'
  },
  play: {
    en: 'Play',
    hi: 'खेलें',
    mr: 'खेळा',
    gu: 'રમો',
    ta: 'விளையாடு',
    te: 'ఆడండి',
    kn: 'ಆಟವಾಡಿ',
    bn: 'খেলুন',
    pa: 'ਖੇਡੋ'
  },
  invite: {
    en: 'Community',
    hi: 'Community',
    mr: 'Community',
    gu: 'Community',
    ta: 'Community',
    te: 'Community',
    kn: 'Community',
    bn: 'Community',
    pa: 'Community'
  },
  upgradeToVip: {
    en: 'Upgrade to VIP',
    hi: 'VIP में अपग्रेड करें',
    mr: 'VIP मध्ये अपग्रेड करा',
    gu: 'VIP માં અપગ્રેડ કરો',
    ta: 'VIP க்கு மேம்படுத்தவும்',
    te: 'VIPకి అప్‌గ్రేడ్ చేయండి',
    kn: 'VIPಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ',
    bn: 'VIP তে আপগ্রেড করুন',
    pa: 'VIP ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ'
  },
  yourProgress: {
    en: 'Your Progress',
    hi: 'आपकी प्रगति',
    mr: 'तुमची प्रगती',
    gu: 'તમારી પ્રગતિ',
    ta: 'உங்கள் முன்னேற்றம்',
    te: 'మీ పురోగతి',
    kn: 'ನಿಮ್ಮ ಪ್ರಗತಿ',
    bn: 'আপনার অগ্রগতি',
    pa: 'ਤੁਹਾਡੀ ਤਰੱਕੀ'
  },
  yourActivity: {
    en: 'Your Activity',
    hi: 'आपकी गतिविधि',
    mr: 'तुमची क्रिया',
    gu: 'તમારી પ્રવૃત્તિ',
    ta: 'உங்கள் செயல்பாடு',
    te: 'మీ కార్యకలాపం',
    kn: 'ನಿಮ್ಮ ಚಟುವಟಿಕೆ',
    bn: 'আপনার কার্যকলাপ',
    pa: 'ਤੁਹਾਡੀ ਗਤੀਵਿਧੀ'
  },
  liveActivity: {
    en: 'Live Activity',
    hi: 'लाइव गतिविधि',
    mr: 'लाइव्ह क्रिया',
    gu: 'લાઇવ પ્રવૃત્તિ',
    ta: 'நேரடி செயல்பாடு',
    te: 'లైవ్ కార్యకలాపం',
    kn: 'ಲೈವ್ ಚಟುವಟಿಕೆ',
    bn: 'লাইভ কার্যকলাপ',
    pa: 'ਲਾਈਵ ਗਤੀਵਿਧੀ'
  },
  noActivityYet: {
    en: 'No activity yet',
    hi: 'अभी कोई गतिविधि नहीं',
    mr: 'अजून कोणतीही क्रिया नाही',
    gu: 'હજુ કોઈ પ્રવૃત્તિ નથી',
    ta: 'இன்னும் செயல்பாடு இல்லை',
    te: 'ఇంకా కార్యకలాపం లేదు',
    kn: 'ಇನ್ನೂ ಚಟುವಟಿಕೆ ಇಲ್ಲ',
    bn: 'এখনও কোনো কার্যকলাপ নেই',
    pa: 'ਅਜੇ ਕੋਈ ਗਤੀਵਿਧੀ ਨਹੀਂ'
  },
  startEarning: {
    en: 'Start Earning',
    hi: 'कमाई शुरू करें',
    mr: 'कमाई सुरू करा',
    gu: 'કમાણી શરૂ કરો',
    ta: 'சம்பாதிக்க தொடங்குங்கள்',
    te: 'సంపాదించడం ప్రారంభించండి',
    kn: 'ಗಳಿಸಲು ಪ್ರಾರಂಭಿಸಿ',
    bn: 'আয় শুরু করুন',
    pa: 'ਕਮਾਈ ਸ਼ੁਰੂ ਕਰੋ'
  },
  viewAllTransactions: {
    en: 'View All Transactions',
    hi: 'सभी लेनदेन देखें',
    mr: 'सर्व व्यवहार पहा',
    gu: 'બધા વ્યવહારો જુઓ',
    ta: 'அனைத்து பரிவர்த்தனைகளையும் காண்க',
    te: 'అన్ని లావాదేవీలు చూడండి',
    kn: 'ಎಲ್ಲಾ ವಹಿವಾಟುಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    bn: 'সব লেনদেন দেখুন',
    pa: 'ਸਾਰੇ ਲੈਣ-ਦੇਣ ਵੇਖੋ'
  },
  balance: {
    en: 'Balance',
    hi: 'शेष',
    mr: 'शिल्लक',
    gu: 'બેલેન્સ',
    ta: 'இருப்பு',
    te: 'బ్యాలెన్స్',
    kn: 'ಬ್ಯಾಲೆನ್ಸ್',
    bn: 'ব্যালেন্স',
    pa: 'ਬੈਲੇਂਸ'
  },
  cardHolder: {
    en: 'Card Holder',
    hi: 'कार्ड धारक',
    mr: 'कार्ड धारक',
    gu: 'કાર્ડ ધારક',
    ta: 'கார்ட் ஹோல்டர்',
    te: 'కార్డ్ హోల్డర్',
    kn: 'ಕಾರ್ಡ್ ಹೋಲ್ಡರ್',
    bn: 'কার্ড হোল্ডার',
    pa: 'ਕਾਰਡ ਹੋਲਡਰ'
  },
  miningSpeed: {
    en: 'Mining Speed',
    hi: 'माइनिंग स्पीड',
    mr: 'माइनिंग स्पीड',
    gu: 'માઇનિંગ સ્પીડ',
    ta: 'மைனிங் வேகம்',
    te: 'మైనింగ్ స్పీడ్',
    kn: 'ಮೈನಿಂಗ್ ಸ್ಪೀಡ್',
    bn: 'মাইনিং স্পিড',
    pa: 'ਮਾਈਨਿੰਗ ਸਪੀਡ'
  },

  // ==================== NETWORK / SOCIAL ====================
  discoverAndConnect: {
    en: 'Discover & Connect',
    hi: 'खोजें और जुड़ें',
    mr: 'शोधा आणि जोडा',
    gu: 'શોધો અને જોડાઓ',
    ta: 'கண்டறிந்து இணையுங்கள்',
    te: 'కనుగొని కనెక్ట్ అవ్వండి',
    kn: 'ಅನ್ವೇಷಿಸಿ ಮತ್ತು ಸಂಪರ್ಕಿಸಿ',
    bn: 'আবিষ্কার করুন এবং সংযুক্ত হন',
    pa: 'ਖੋਜੋ ਅਤੇ ਜੁੜੋ'
  },
  searchUsers: {
    en: 'Search by name, city, or state...',
    hi: 'नाम, शहर या राज्य से खोजें...',
    mr: 'नाव, शहर किंवा राज्याने शोधा...',
    gu: 'નામ, શહેર અથવા રાજ્ય દ્વારા શોધો...',
    ta: 'பெயர், நகரம் அல்லது மாநிலம் மூலம் தேடுங்கள்...',
    te: 'పేరు, నగరం లేదా రాష్ట్రం ద్వారా వెతకండి...',
    kn: 'ಹೆಸರು, ನಗರ ಅಥವಾ ರಾಜ್ಯದಿಂದ ಹುಡುಕಿ...',
    bn: 'নাম, শহর বা রাজ্য দ্বারা খুঁজুন...',
    pa: 'ਨਾਮ, ਸ਼ਹਿਰ ਜਾਂ ਰਾਜ ਦੁਆਰਾ ਖੋਜੋ...'
  },
  searchResults: {
    en: 'Search results',
    hi: 'खोज परिणाम',
    mr: 'शोध परिणाम',
    gu: 'શોધ પરિણામો',
    ta: 'தேடல் முடிவுகள்',
    te: 'శోధన ఫలితాలు',
    kn: 'ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು',
    bn: 'অনুসন্ধান ফলাফল',
    pa: 'ਖੋਜ ਨਤੀਜੇ'
  },
  noUsersFound: {
    en: 'No users found',
    hi: 'कोई उपयोगकर्ता नहीं मिला',
    mr: 'कोणतेही वापरकर्ते आढळले नाहीत',
    gu: 'કોઈ વપરાશકર્તા મળ્યા નથી',
    ta: 'பயனர்கள் எதுவும் கிடைக்கவில்லை',
    te: 'వినియోగదారులు కనుగొనబడలేదు',
    kn: 'ಬಳಕೆದಾರರು ಕಂಡುಬಂದಿಲ್ಲ',
    bn: 'কোনো ব্যবহারকারী পাওয়া যায়নি',
    pa: 'ਕੋਈ ਉਪਭੋਗਤਾ ਨਹੀਂ ਮਿਲਿਆ'
  },
  global: {
    en: 'Global',
    hi: 'वैश्विक',
    mr: 'जागतिक',
    gu: 'વૈશ્વિક',
    ta: 'உலகளாவிய',
    te: 'గ్లోబల్',
    kn: 'ಜಾಗತಿಕ',
    bn: 'বিশ্বব্যাপী',
    pa: 'ਗਲੋਬਲ'
  },
  suggestedForYou: {
    en: 'Suggested for You',
    hi: 'आपके लिए सुझाव',
    mr: 'तुमच्यासाठी सुचवलेले',
    gu: 'તમારા માટે સૂચવેલ',
    ta: 'உங்களுக்கான பரிந்துரைகள்',
    te: 'మీ కోసం సూచించబడింది',
    kn: 'ನಿಮಗಾಗಿ ಸೂಚಿಸಲಾಗಿದೆ',
    bn: 'আপনার জন্য প্রস্তাবিত',
    pa: 'ਤੁਹਾਡੇ ਲਈ ਸੁਝਾਅ'
  },
  seeAll: {
    en: 'See all',
    hi: 'सभी देखें',
    mr: 'सर्व पहा',
    gu: 'બધું જુઓ',
    ta: 'அனைத்தையும் காண்க',
    te: 'అన్నీ చూడండి',
    kn: 'ಎಲ್ಲಾ ನೋಡಿ',
    bn: 'সব দেখুন',
    pa: 'ਸਭ ਵੇਖੋ'
  },
  globalActivity: {
    en: 'Global Activity',
    hi: 'वैश्विक गतिविधि',
    mr: 'जागतिक क्रिया',
    gu: 'વૈશ્વિક પ્રવૃત્તિ',
    ta: 'உலகளாவிய செயல்பாடு',
    te: 'గ్లోబల్ కార్యకలాపం',
    kn: 'ಜಾಗತಿಕ ಚಟುವಟಿಕೆ',
    bn: 'বিশ্বব্যাপী কার্যকলাপ',
    pa: 'ਗਲੋਬਲ ਗਤੀਵਿਧੀ'
  },
  yourNetwork: {
    en: 'Your Network',
    hi: 'आपका नेटवर्क',
    mr: 'तुमचे नेटवर्क',
    gu: 'તમારું નેટવર્ક',
    ta: 'உங்கள் நெட்வொர்க்',
    te: 'మీ నెట్‌వర్క్',
    kn: 'ನಿಮ್ಮ ನೆಟ್‌ವರ್ಕ್',
    bn: 'আপনার নেটওয়ার্ক',
    pa: 'ਤੁਹਾਡਾ ਨੈੱਟਵਰਕ'
  },
  noActivityFromNetwork: {
    en: 'No activity from your network',
    hi: 'आपके नेटवर्क से कोई गतिविधि नहीं',
    mr: 'तुमच्या नेटवर्कवरून कोणतीही क्रिया नाही',
    gu: 'તમારા નેટવર્કમાંથી કોઈ પ્રવૃત્તિ નથી',
    ta: 'உங்கள் நெட்வொர்க்கிலிருந்து செயல்பாடு இல்லை',
    te: 'మీ నెట్‌వర్క్ నుండి కార్యకలాపం లేదు',
    kn: 'ನಿಮ್ಮ ನೆಟ್‌ವರ್ಕ್‌ನಿಂದ ಚಟುವಟಿಕೆ ಇಲ್ಲ',
    bn: 'আপনার নেটওয়ার্ক থেকে কোনো কার্যকলাপ নেই',
    pa: 'ਤੁਹਾਡੇ ਨੈੱਟਵਰਕ ਤੋਂ ਕੋਈ ਗਤੀਵਿਧੀ ਨਹੀਂ'
  },
  followUsersToSee: {
    en: 'Follow users to see their activity here',
    hi: 'उनकी गतिविधि देखने के लिए उपयोगकर्ताओं को फॉलो करें',
    mr: 'त्यांची क्रिया पाहण्यासाठी वापरकर्त्यांना फॉलो करा',
    gu: 'તેમની પ્રવૃત્તિ જોવા માટે વપરાશકર્તાઓને ફોલો કરો',
    ta: 'அவர்களின் செயல்பாட்டைக் காண பயனர்களைப் பின்தொடரவும்',
    te: 'వారి కార్యకలాపం చూడటానికి వినియోగదారులను ఫాలో చేయండి',
    kn: 'ಅವರ ಚಟುವಟಿಕೆಯನ್ನು ನೋಡಲು ಬಳಕೆದಾರರನ್ನು ಅನುಸರಿಸಿ',
    bn: 'তাদের কার্যকলাপ দেখতে ব্যবহারকারীদের অনুসরণ করুন',
    pa: 'ਉਹਨਾਂ ਦੀ ਗਤੀਵਿਧੀ ਦੇਖਣ ਲਈ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਫਾਲੋ ਕਰੋ'
  },
  // (duplicate `loadMore` entry removed — see definition earlier in file)
  showingActivities: {
    en: 'Showing {count} activities',
    hi: '{count} गतिविधियां दिखा रहे हैं',
    mr: '{count} क्रिया दाखवत आहे',
    gu: '{count} પ્રવૃત્તિઓ બતાવી રહ્યા છીએ',
    ta: '{count} செயல்பாடுகளைக் காண்பிக்கிறது',
    te: '{count} కార్యకలాపాలు చూపిస్తోంది',
    kn: '{count} ಚಟುವಟಿಕೆಗಳನ್ನು ತೋರಿಸುತ್ತಿದೆ',
    bn: '{count} কার্যকলাপ দেখাচ্ছে',
    pa: '{count} ਗਤੀਵਿਧੀਆਂ ਦਿਖਾ ਰਿਹਾ ਹੈ'
  },
  allActivitiesLoaded: {
    en: 'All activities loaded',
    hi: 'सभी गतिविधियां लोड हो गईं',
    mr: 'सर्व क्रिया लोड झाल्या',
    gu: 'બધી પ્રવૃત્તિઓ લોડ થઈ ગઈ',
    ta: 'அனைத்து செயல்பாடுகளும் ஏற்றப்பட்டன',
    te: 'అన్ని కార్యకలాపాలు లోడ్ అయ్యాయి',
    kn: 'ಎಲ್ಲಾ ಚಟುವಟಿಕೆಗಳು ಲೋಡ್ ಆಗಿವೆ',
    bn: 'সব কার্যকলাপ লোড হয়েছে',
    pa: 'ਸਾਰੀਆਂ ਗਤੀਵਿਧੀਆਂ ਲੋਡ ਹੋ ਗਈਆਂ'
  },

  // ==================== MESSAGES ====================
  searchConversations: {
    en: 'Search conversations...',
    hi: 'बातचीत खोजें...',
    mr: 'संवाद शोधा...',
    gu: 'વાર્તાલાપ શોધો...',
    ta: 'உரையாடல்களைத் தேடுங்கள்...',
    te: 'సంభాషణలు వెతకండి...',
    kn: 'ಸಂಭಾಷಣೆಗಳನ್ನು ಹುಡುಕಿ...',
    bn: 'কথোপকথন খুঁজুন...',
    pa: 'ਗੱਲਬਾਤ ਖੋਜੋ...'
  },
  noMessagesYet: {
    en: 'No messages yet',
    hi: 'अभी कोई संदेश नहीं',
    mr: 'अजून कोणतेही संदेश नाहीत',
    gu: 'હજુ કોઈ સંદેશ નથી',
    ta: 'இன்னும் செய்திகள் இல்லை',
    te: 'ఇంకా సందేశాలు లేవు',
    kn: 'ಇನ್ನೂ ಸಂದೇಶಗಳಿಲ್ಲ',
    bn: 'এখনও কোনো বার্তা নেই',
    pa: 'ਅਜੇ ਕੋਈ ਸੁਨੇਹਾ ਨਹੀਂ'
  },
  startConversation: {
    en: "Start a conversation from someone's profile",
    hi: 'किसी की प्रोफ़ाइल से बातचीत शुरू करें',
    mr: 'कोणाच्या प्रोफाइलवरून संवाद सुरू करा',
    gu: 'કોઈની પ્રોફાઇલમાંથી વાતચીત શરૂ કરો',
    ta: 'யாரோ ஒருவரின் சுயவிவரத்தில் இருந்து உரையாடலைத் தொடங்குங்கள்',
    te: 'ఎవరైనా ప్రొఫైల్ నుండి సంభాషణ ప్రారంభించండి',
    kn: 'ಯಾರದಾದರೂ ಪ್ರೊಫೈಲ್‌ನಿಂದ ಸಂಭಾಷಣೆ ಪ್ರಾರಂಭಿಸಿ',
    bn: 'কারো প্রোফাইল থেকে কথোপকথন শুরু করুন',
    pa: 'ਕਿਸੇ ਦੀ ਪ੍ਰੋਫਾਈਲ ਤੋਂ ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ'
  },
  findPeople: {
    en: 'Find People',
    hi: 'लोग खोजें',
    mr: 'लोक शोधा',
    gu: 'લોકો શોધો',
    ta: 'மக்களைக் கண்டறியுங்கள்',
    te: 'వ్యక్తులను కనుగొనండి',
    kn: 'ಜನರನ್ನು ಹುಡುಕಿ',
    bn: 'মানুষ খুঁজুন',
    pa: 'ਲੋਕ ਲੱਭੋ'
  },
  tapToViewProfile: {
    en: 'Tap to view profile',
    hi: 'प्रोफ़ाइल देखने के लिए टैप करें',
    mr: 'प्रोफाइल पाहण्यासाठी टॅप करा',
    gu: 'પ્રોફાઇલ જોવા ટેપ કરો',
    ta: 'சுயவிவரத்தைக் காண தட்டவும்',
    te: 'ప్రొఫైల్ చూడటానికి ట్యాప్ చేయండి',
    kn: 'ಪ್ರೊಫೈಲ್ ವೀಕ್ಷಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ',
    bn: 'প্রোফাইল দেখতে ট্যাপ করুন',
    pa: 'ਪ੍ਰੋਫਾਈਲ ਵੇਖਣ ਲਈ ਟੈਪ ਕਰੋ'
  },
  startConversationWith: {
    en: 'Start a conversation with {name}',
    hi: '{name} के साथ बातचीत शुरू करें',
    mr: '{name} सोबत संवाद सुरू करा',
    gu: '{name} સાથે વાતચીત શરૂ કરો',
    ta: '{name} உடன் உரையாடலைத் தொடங்குங்கள்',
    te: '{name}తో సంభాషణ ప్రారంభించండి',
    kn: '{name} ಜೊತೆ ಸಂಭಾಷಣೆ ಪ್ರಾರಂಭಿಸಿ',
    bn: '{name} এর সাথে কথোপকথন শুরু করুন',
    pa: '{name} ਨਾਲ ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ'
  },

  // ==================== NOTIFICATIONS ====================
  allCaughtUpNotifications: {
    en: 'All caught up!',
    hi: 'सब पढ़ लिया!',
    mr: 'सर्व वाचले!',
    gu: 'બધું વાંચ્યું!',
    ta: 'எல்லாம் படித்தாயிற்று!',
    te: 'అన్నీ చదివారు!',
    kn: 'ಎಲ್ಲಾ ಓದಿದ್ದೀರಿ!',
    bn: 'সব পড়া হয়ে গেছে!',
    pa: 'ਸਭ ਪੜ੍ਹ ਲਿਆ!'
  },
  noNotifications: {
    en: 'No notifications',
    hi: 'कोई सूचना नहीं',
    mr: 'कोणत्याही सूचना नाहीत',
    gu: 'કોઈ સૂચનાઓ નથી',
    ta: 'அறிவிப்புகள் இல்லை',
    te: 'నోటిఫికేషన్లు లేవు',
    kn: 'ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',
    bn: 'কোনো বিজ্ঞপ্তি নেই',
    pa: 'ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ'
  },
  youveReadAll: {
    en: "You've read all your notifications!",
    hi: 'आपने सभी सूचनाएं पढ़ लीं!',
    mr: 'तुम्ही सर्व सूचना वाचल्या!',
    gu: 'તમે બધી સૂચનાઓ વાંચી લીધી!',
    ta: 'நீங்கள் எல்லா அறிவிப்புகளையும் படித்துவிட்டீர்கள்!',
    te: 'మీరు అన్ని నోటిఫికేషన్లు చదివారు!',
    kn: 'ನೀವು ಎಲ್ಲಾ ಅಧಿಸೂಚನೆಗಳನ್ನು ಓದಿದ್ದೀರಿ!',
    bn: 'আপনি সব বিজ্ঞপ্তি পড়েছেন!',
    pa: 'ਤੁਸੀਂ ਸਾਰੀਆਂ ਸੂਚਨਾਵਾਂ ਪੜ੍ਹ ਲਈਆਂ!'
  },
  youllSeeNotifications: {
    en: "You'll see new followers and messages here",
    hi: 'यहां आपको नए फॉलोअर्स और संदेश दिखेंगे',
    mr: 'येथे तुम्हाला नवीन फॉलोअर्स आणि संदेश दिसतील',
    gu: 'અહીં તમને નવા ફોલોઅર્સ અને સંદેશ દેખાશે',
    ta: 'இங்கே புதிய பின்தொடர்பவர்கள் மற்றும் செய்திகள் தெரியும்',
    te: 'ఇక్కడ మీకు కొత్త ఫాలోవర్లు మరియు సందేశాలు కనిపిస్తాయి',
    kn: 'ಇಲ್ಲಿ ನಿಮಗೆ ಹೊಸ ಅನುಯಾಯಿಗಳು ಮತ್ತು ಸಂದೇಶಗಳು ಕಾಣಿಸುತ್ತವೆ',
    bn: 'এখানে আপনি নতুন অনুসরণকারী এবং বার্তা দেখতে পাবেন',
    pa: 'ਇੱਥੇ ਤੁਹਾਨੂੰ ਨਵੇਂ ਫਾਲੋਅਰ ਅਤੇ ਸੁਨੇਹੇ ਦਿਖਾਈ ਦੇਣਗੇ'
  },
  readAll: {
    en: 'Read all',
    hi: 'सभी पढ़ें',
    mr: 'सर्व वाचा',
    gu: 'બધું વાંચો',
    ta: 'அனைத்தையும் படிக்கவும்',
    te: 'అన్నీ చదవండి',
    kn: 'ಎಲ್ಲಾ ಓದಿ',
    bn: 'সব পড়ুন',
    pa: 'ਸਭ ਪੜ੍ਹੋ'
  },
  clear: {
    en: 'Clear',
    hi: 'साफ करें',
    mr: 'साफ करा',
    gu: 'સાફ કરો',
    ta: 'அழி',
    te: 'క్లియర్ చేయండి',
    kn: 'ತೆರವುಗೊಳಿಸಿ',
    bn: 'মুছুন',
    pa: 'ਸਾਫ਼ ਕਰੋ'
  },
  justNow: {
    en: 'Just now',
    hi: 'अभी अभी',
    mr: 'आत्ताच',
    gu: 'હમણાં જ',
    ta: 'இப்போது',
    te: 'ఇప్పుడే',
    kn: 'ಈಗಷ್ಟೇ',
    bn: 'এইমাত্র',
    pa: 'ਹੁਣੇ'
  },
  minutesAgo: {
    en: '{count} minutes ago',
    hi: '{count} मिनट पहले',
    mr: '{count} मिनिटांपूर्वी',
    gu: '{count} મિનિટ પહેલાં',
    ta: '{count} நிமிடங்களுக்கு முன்',
    te: '{count} నిమిషాల క్రితం',
    kn: '{count} ನಿಮಿಷಗಳ ಹಿಂದೆ',
    bn: '{count} মিনিট আগে',
    pa: '{count} ਮਿੰਟ ਪਹਿਲਾਂ'
  },
  hoursAgo: {
    en: '{count} hours ago',
    hi: '{count} घंटे पहले',
    mr: '{count} तासांपूर्वी',
    gu: '{count} કલાક પહેલાં',
    ta: '{count} மணி நேரத்திற்கு முன்',
    te: '{count} గంటల క్రితం',
    kn: '{count} ಗಂಟೆಗಳ ಹಿಂದೆ',
    bn: '{count} ঘন্টা আগে',
    pa: '{count} ਘੰਟੇ ਪਹਿਲਾਂ'
  },
  daysAgo: {
    en: '{count} days ago',
    hi: '{count} दिन पहले',
    mr: '{count} दिवसांपूर्वी',
    gu: '{count} દિવસ પહેલાં',
    ta: '{count} நாட்களுக்கு முன்',
    te: '{count} రోజుల క్రితం',
    kn: '{count} ದಿನಗಳ ಹಿಂದೆ',
    bn: '{count} দিন আগে',
    pa: '{count} ਦਿਨ ਪਹਿਲਾਂ'
  },

  // ==================== GIFT VOUCHERS ====================
  giftVouchersTitle: {
    en: 'Gift Vouchers',
    hi: 'गिफ्ट वाउचर',
    mr: 'गिफ्ट व्हाउचर्स',
    gu: 'ગિફ્ટ વાઉચર્સ',
    ta: 'பரிசு வவுச்சர்கள்',
    te: 'గిఫ్ట్ వౌచర్లు',
    kn: 'ಗಿಫ್ಟ್ ವೌಚರ್‌ಗಳು',
    bn: 'গিফট ভাউচার',
    pa: 'ਗਿਫ਼ਟ ਵਾਊਚਰ'
  },
  redeemPRCForVouchers: {
    en: 'Redeem PRC for PhonePe vouchers',
    hi: 'PhonePe वाउचर के लिए PRC का उपयोग करें',
    mr: 'PhonePe व्हाउचरसाठी PRC वापरा',
    gu: 'PhonePe વાઉચર માટે PRC વાપરો',
    ta: 'PhonePe வவுச்சர்களுக்கு PRC பயன்படுத்துங்கள்',
    te: 'PhonePe వౌచర్ల కోసం PRC వాడండి',
    kn: 'PhonePe ವೌಚರ್‌ಗಳಿಗಾಗಿ PRC ಬಳಸಿ',
    bn: 'PhonePe ভাউচারের জন্য PRC ব্যবহার করুন',
    pa: 'PhonePe ਵਾਊਚਰ ਲਈ PRC ਵਰਤੋ'
  },
  selectVoucherAmount: {
    en: 'Select Voucher Amount',
    hi: 'वाउचर राशि चुनें',
    mr: 'व्हाउचर रक्कम निवडा',
    gu: 'વાઉચર રકમ પસંદ કરો',
    ta: 'வவுச்சர் தொகையைத் தேர்ந்தெடுக்கவும்',
    te: 'వౌచర్ మొత్తం ఎంచుకోండి',
    kn: 'ವೌಚರ್ ಮೊತ್ತವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    bn: 'ভাউচার পরিমাণ নির্বাচন করুন',
    pa: 'ਵਾਊਚਰ ਰਕਮ ਚੁਣੋ'
  },
  orderSummary: {
    en: 'Order Summary',
    hi: 'ऑर्डर सारांश',
    mr: 'ऑर्डर सारांश',
    gu: 'ઓર્ડર સારાંશ',
    ta: 'ஆர்டர் சுருக்கம்',
    te: 'ఆర్డర్ సారాంశం',
    kn: 'ಆರ್ಡರ್ ಸಾರಾಂಶ',
    bn: 'অর্ডার সারসংক্ষেপ',
    pa: 'ਆਰਡਰ ਸਾਰ'
  },
  voucherValue: {
    en: 'Voucher Value',
    hi: 'वाउचर मूल्य',
    mr: 'व्हाउचर मूल्य',
    gu: 'વાઉચર મૂલ્ય',
    ta: 'வவுச்சர் மதிப்பு',
    te: 'వౌచర్ విలువ',
    kn: 'ವೌಚರ್ ಮೌಲ್ಯ',
    bn: 'ভাউচার মূল্য',
    pa: 'ਵਾਊਚਰ ਮੁੱਲ'
  },
  prcRequired: {
    en: 'PRC Required',
    hi: 'आवश्यक PRC',
    mr: 'आवश्यक PRC',
    gu: 'જરૂરી PRC',
    ta: 'தேவையான PRC',
    te: 'అవసరమైన PRC',
    kn: 'ಅಗತ್ಯವಿರುವ PRC',
    bn: 'প্রয়োজনীয় PRC',
    pa: 'ਲੋੜੀਂਦਾ PRC'
  },
  serviceCharge: {
    en: 'Service Charge (~5%)',
    hi: 'सेवा शुल्क (~5%)',
    mr: 'सेवा शुल्क (~5%)',
    gu: 'સેવા શુલ્ક (~5%)',
    ta: 'சேவை கட்டணம் (~5%)',
    te: 'సేవా రుసుము (~5%)',
    kn: 'ಸೇವಾ ಶುಲ್ಕ (~5%)',
    bn: 'সার্ভিস চার্জ (~5%)',
    pa: 'ਸੇਵਾ ਚਾਰਜ (~5%)'
  },
  redeemVoucher: {
    en: 'Redeem Voucher',
    hi: 'वाउचर रिडीम करें',
    mr: 'व्हाउचर रिडीम करा',
    gu: 'વાઉચર રિડીમ કરો',
    ta: 'வவுச்சர் ரிடீம் செய்யவும்',
    te: 'వౌచర్ రీడీమ్ చేయండి',
    kn: 'ವೌಚರ್ ರಿಡೀಮ್ ಮಾಡಿ',
    bn: 'ভাউচার রিডিম করুন',
    pa: 'ਵਾਊਚਰ ਰੀਡੀਮ ਕਰੋ'
  },
  whyPhonePeVouchers: {
    en: 'Why PhonePe Vouchers?',
    hi: 'PhonePe वाउचर क्यों?',
    mr: 'PhonePe व्हाउचर का?',
    gu: 'PhonePe વાઉચર શા માટે?',
    ta: 'PhonePe வவுச்சர் ஏன்?',
    te: 'PhonePe వౌచర్లు ఎందుకు?',
    kn: 'PhonePe ವೌಚರ್‌ಗಳು ಏಕೆ?',
    bn: 'PhonePe ভাউচার কেন?',
    pa: 'PhonePe ਵਾਊਚਰ ਕਿਉਂ?'
  },
  useAnywhere: {
    en: 'Use anywhere',
    hi: 'कहीं भी उपयोग करें',
    mr: 'कुठेही वापरा',
    gu: 'ક્યાંય પણ વાપરો',
    ta: 'எங்கும் பயன்படுத்துங்கள்',
    te: 'ఎక్కడైనా వాడండి',
    kn: 'ಎಲ್ಲಿಯಾದರೂ ಬಳಸಿ',
    bn: 'যে কোথাও ব্যবহার করুন',
    pa: 'ਕਿਤੇ ਵੀ ਵਰਤੋ'
  },
  multipleAmounts: {
    en: 'Multiple amounts',
    hi: 'कई राशियां',
    mr: 'अनेक रक्कम',
    gu: 'ઘણી રકમો',
    ta: 'பல தொகைகள்',
    te: 'బహుళ మొత్తాలు',
    kn: 'ಬಹು ಮೊತ್ತಗಳು',
    bn: 'একাধিক পরিমাণ',
    pa: 'ਕਈ ਰਕਮਾਂ'
  },
  fastProcessing: {
    en: 'Fast processing',
    hi: 'तेज़ प्रक्रिया',
    mr: 'जलद प्रक्रिया',
    gu: 'ઝડપી પ્રક્રિયા',
    ta: 'விரைவான செயலாக்கம்',
    te: 'వేగవంతమైన ప్రాసెసింగ్',
    kn: 'ವೇಗದ ಪ್ರಕ್ರಿಯೆ',
    bn: 'দ্রুত প্রক্রিয়াকরণ',
    pa: 'ਤੇਜ਼ ਪ੍ਰੋਸੈਸਿੰਗ'
  },
  perfectForGifts: {
    en: 'Perfect for gifts',
    hi: 'उपहारों के लिए बिल्कुल सही',
    mr: 'भेटवस्तूंसाठी योग्य',
    gu: 'ભેટ માટે યોગ્ય',
    ta: 'பரிசுகளுக்கு சிறந்தது',
    te: 'బహుమతులకు అనువైనది',
    kn: 'ಉಡುಗೊರೆಗಳಿಗೆ ಸೂಕ್ತ',
    bn: 'উপহারের জন্য নিখুঁত',
    pa: 'ਤੋਹਫ਼ਿਆਂ ਲਈ ਬਿਲਕੁਲ ਸਹੀ'
  },
  voucherHistory: {
    en: 'Voucher History',
    hi: 'वाउचर इतिहास',
    mr: 'व्हाउचर इतिहास',
    gu: 'વાઉચર ઇતિહાસ',
    ta: 'வவுச்சர் வரலாறு',
    te: 'వౌచర్ చరిత్ర',
    kn: 'ವೌಚರ್ ಇತಿಹಾಸ',
    bn: 'ভাউচার ইতিহাস',
    pa: 'ਵਾਊਚਰ ਇਤਿਹਾਸ'
  },
  processingTime: {
    en: 'Processing: 3-7 days',
    hi: 'प्रोसेसिंग: 3-7 दिन',
    mr: 'प्रक्रिया: 3-7 दिवस',
    gu: 'પ્રક્રિયા: 3-7 દિવસ',
    ta: 'செயலாக்கம்: 3-7 நாட்கள்',
    te: 'ప్రాసెసింగ్: 3-7 రోజులు',
    kn: 'ಪ್ರಕ್ರಿಯೆ: 3-7 ದಿನಗಳು',
    bn: 'প্রক্রিয়াকরণ: 3-7 দিন',
    pa: 'ਪ੍ਰੋਸੈਸਿੰਗ: 3-7 ਦਿਨ'
  },
  noVoucherRequestsYet: {
    en: 'No voucher requests yet',
    hi: 'अभी कोई वाउचर अनुरोध नहीं',
    mr: 'अजून व्हाउचर विनंती नाही',
    gu: 'હજુ કોઈ વાઉચર વિનંતી નથી',
    ta: 'இன்னும் வவுச்சர் கோரிக்கைகள் இல்லை',
    te: 'ఇంకా వౌచర్ అభ్యర్థనలు లేవు',
    kn: 'ಇನ್ನೂ ವೌಚರ್ ವಿನಂತಿಗಳಿಲ್ಲ',
    bn: 'এখনও কোনো ভাউচার অনুরোধ নেই',
    pa: 'ਅਜੇ ਕੋਈ ਵਾਊਚਰ ਬੇਨਤੀ ਨਹੀਂ'
  },
  voucherCode: {
    en: 'Voucher Code',
    hi: 'वाउचर कोड',
    mr: 'व्हाउचर कोड',
    gu: 'વાઉચર કોડ',
    ta: 'வவுச்சர் குறியீடு',
    te: 'వౌచర్ కోడ్',
    kn: 'ವೌಚರ್ ಕೋಡ್',
    bn: 'ভাউচার কোড',
    pa: 'ਵਾਊਚਰ ਕੋਡ'
  },
  prcDeducted: {
    en: 'PRC Deducted',
    hi: 'PRC कटौती',
    mr: 'PRC वजा',
    gu: 'PRC કપાત',
    ta: 'PRC கழிக்கப்பட்டது',
    te: 'PRC తీసివేయబడింది',
    kn: 'PRC ಕಡಿತ',
    bn: 'PRC কেটে নেওয়া হয়েছে',
    pa: 'PRC ਕਟੌਤੀ'
  },
  popular: {
    en: 'Popular',
    hi: 'लोकप्रिय',
    mr: 'लोकप्रिय',
    gu: 'લોકપ્રિય',
    ta: 'பிரபலமான',
    te: 'ప్రాచుర్యం',
    kn: 'ಜನಪ್ರಿಯ',
    bn: 'জনপ্রিয়',
    pa: 'ਪ੍ਰਸਿੱਧ'
  },
  prev: {
    en: 'Prev',
    hi: 'पिछला',
    mr: 'मागील',
    gu: 'પાછલું',
    ta: 'முந்தைய',
    te: 'మునుపటి',
    kn: 'ಹಿಂದಿನ',
    bn: 'আগের',
    pa: 'ਪਿਛਲਾ'
  },

  // ==================== SUBSCRIPTION ====================
  subscriptionPlans: {
    en: 'Subscription Plans',
    hi: 'सदस्यता योजनाएं',
    mr: 'सदस्यता प्लॅन',
    gu: 'સબ્સ્ક્રિપ્શન પ્લાન',
    ta: 'சந்தா திட்டங்கள்',
    te: 'సబ్‌స్క్రిప్షన్ ప్లాన్‌లు',
    kn: 'ಸಬ್‌ಸ್ಕ್ರಿಪ್ಷನ್ ಪ್ಲಾನ್‌ಗಳು',
    bn: 'সাবস্ক্রিপশন প্ল্যান',
    pa: 'ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਪਲਾਨ'
  },
  chooseYourPlan: {
    en: 'Choose Your Plan',
    hi: 'अपना प्लान चुनें',
    mr: 'तुमचा प्लॅन निवडा',
    gu: 'તમારો પ્લાન પસંદ કરો',
    ta: 'உங்கள் திட்டத்தைத் தேர்ந்தெடுக்கவும்',
    te: 'మీ ప్లాన్ ఎంచుకోండి',
    kn: 'ನಿಮ್ಮ ಪ್ಲಾನ್ ಆಯ್ಕೆಮಾಡಿ',
    bn: 'আপনার প্ল্যান বেছে নিন',
    pa: 'ਆਪਣਾ ਪਲਾਨ ਚੁਣੋ'
  },
  selectDuration: {
    en: 'Select Duration',
    hi: 'अवधि चुनें',
    mr: 'कालावधी निवडा',
    gu: 'સમયગાળો પસંદ કરો',
    ta: 'காலத்தைத் தேர்ந்தெடுக்கவும்',
    te: 'వ్యవధిని ఎంచుకోండి',
    kn: 'ಅವಧಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    bn: 'সময়কাল নির্বাচন করুন',
    pa: 'ਮਿਆਦ ਚੁਣੋ'
  },
  monthly: {
    en: 'Monthly',
    hi: 'मासिक',
    mr: 'मासिक',
    gu: 'માસિક',
    ta: 'மாதாந்திர',
    te: 'నెలవారీ',
    kn: 'ಮಾಸಿಕ',
    bn: 'মাসিক',
    pa: 'ਮਹੀਨਾਵਾਰ'
  },
  quarterly: {
    en: 'Quarterly',
    hi: 'त्रैमासिक',
    mr: 'त्रैमासिक',
    gu: 'ત्रیમાસિક',
    ta: 'காலாண்டு',
    te: 'త్రైమాసిక',
    kn: 'ತ್ರೈಮಾಸಿಕ',
    bn: 'ত্রৈমাসিক',
    pa: 'ਤਿਮਾਹੀ'
  },
  halfYearly: {
    en: 'Half Yearly',
    hi: 'छमाही',
    mr: 'अर्धवार्षिक',
    gu: 'અર્ધવાર્ષિક',
    ta: 'அரை ஆண்டு',
    te: 'అర్ధ సంవత్సరం',
    kn: 'ಅರ್ಧ ವಾರ್ಷಿಕ',
    bn: 'অর্ধ বার্ষিক',
    pa: 'ਛਿਮਾਹੀ'
  },
  yearly: {
    en: 'Yearly',
    hi: 'वार्षिक',
    mr: 'वार्षिक',
    gu: 'વાર્ષિક',
    ta: 'வருடாந்திர',
    te: 'వార్షిక',
    kn: 'ವಾರ್ಷಿಕ',
    bn: 'বার্ষিক',
    pa: 'ਸਾਲਾਨਾ'
  },
  planComparison: {
    en: 'Plan Comparison',
    hi: 'प्लान तुलना',
    mr: 'प्लॅन तुलना',
    gu: 'પ્લાન તુલના',
    ta: 'திட்ட ஒப்பீடு',
    te: 'ప్లాన్ పోలిక',
    kn: 'ಪ್ಲಾನ್ ಹೋಲಿಕೆ',
    bn: 'প্ল্যান তুলনা',
    pa: 'ਪਲਾਨ ਤੁਲਨਾ'
  },
  feature: {
    en: 'Feature',
    hi: 'विशेषता',
    mr: 'वैशिष्ट्य',
    gu: 'ફીચર',
    ta: 'அம்சம்',
    te: 'ఫీచర్',
    kn: 'ಫೀಚರ್',
    bn: 'ফিচার',
    pa: 'ਫੀਚਰ'
  },
  miningRate: {
    en: 'Mining Rate',
    hi: 'माइनिंग दर',
    mr: 'माइनिंग दर',
    gu: 'માઇનિંગ દર',
    ta: 'மைனிங் விகிதம்',
    te: 'మైనింగ్ రేటు',
    kn: 'ಮೈನಿಂಗ್ ದರ',
    bn: 'মাইনিং রেট',
    pa: 'ਮਾਈਨਿੰਗ ਦਰ'
  },
  dailyTapsLimit: {
    en: 'Daily Taps',
    hi: 'दैनिक टैप',
    mr: 'दैनिक टॅप',
    gu: 'દૈનિક ટેપ',
    ta: 'தினசரி தட்டல்கள்',
    te: 'రోజువారీ ట్యాప్‌లు',
    kn: 'ದೈನಿಕ ಟ್ಯಾಪ್‌ಗಳು',
    bn: 'দৈনিক ট্যাপ',
    pa: 'ਰੋਜ਼ਾਨਾ ਟੈਪ'
  },
  referralWeight: {
    en: 'Referral Weight',
    hi: 'रेफरल वेट',
    mr: 'रेफरल वेट',
    gu: 'રેફરલ વેઈટ',
    ta: 'பரிந்துரை எடை',
    te: 'రెఫరల్ వెయిట్',
    kn: 'ರೆಫರಲ್ ವೇಟ್',
    bn: 'রেফারেল ওয়েট',
    pa: 'ਰੈਫਰਲ ਵੇਟ'
  },
  canRedeem: {
    en: 'Can Redeem',
    hi: 'रिडीम कर सकते हैं',
    mr: 'रिडीम करू शकता',
    gu: 'રિડીમ કરી શકો છો',
    ta: 'ரிடீம் செய்யலாம்',
    te: 'రీడీమ్ చేయవచ్చు',
    kn: 'ರಿಡೀಮ್ ಮಾಡಬಹುದು',
    bn: 'রিডিম করতে পারবেন',
    pa: 'ਰੀਡੀਮ ਕਰ ਸਕਦੇ ਹੋ'
  },
  prcExpires: {
    en: 'PRC Expires',
    hi: 'PRC समाप्त होता है',
    mr: 'PRC समाप्त होतो',
    gu: 'PRC સમાપ્ત થાય છે',
    ta: 'PRC காலாவதி ஆகிறது',
    te: 'PRC గడువు ముగుస్తుంది',
    kn: 'PRC ಅವಧಿ ಮುಗಿಯುತ್ತದೆ',
    bn: 'PRC মেয়াদ শেষ হয়',
    pa: 'PRC ਦੀ ਮਿਆਦ ਖਤਮ ਹੁੰਦੀ ਹੈ'
  },
  never: {
    en: 'Never',
    hi: 'कभी नहीं',
    mr: 'कधीच नाही',
    gu: 'ક્યારેય નહીં',
    ta: 'ஒருபோதும் இல்லை',
    te: 'ఎప్పటికీ కాదు',
    kn: 'ಎಂದಿಗೂ ಇಲ್ಲ',
    bn: 'কখনই না',
    pa: 'ਕਦੇ ਨਹੀਂ'
  },
  days: {
    en: 'days',
    hi: 'दिन',
    mr: 'दिवस',
    gu: 'દિવસ',
    ta: 'நாட்கள்',
    te: 'రోజులు',
    kn: 'ದಿನಗಳು',
    bn: 'দিন',
    pa: 'ਦਿਨ'
  },
  current: {
    en: 'Current',
    hi: 'वर्तमान',
    mr: 'सध्याचे',
    gu: 'વર્તમાન',
    ta: 'தற்போதைய',
    te: 'ప్రస్తుత',
    kn: 'ಪ್ರಸ್ತುತ',
    bn: 'বর্তমান',
    pa: 'ਮੌਜੂਦਾ'
  },
  best: {
    en: 'BEST',
    hi: 'सर्वश्रेष्ठ',
    mr: 'सर्वोत्तम',
    gu: 'શ્રેષ્ઠ',
    ta: 'சிறந்தது',
    te: 'ఉత్తమం',
    kn: 'ಅತ್ಯುತ್ತಮ',
    bn: 'সেরা',
    pa: 'ਸਭ ਤੋਂ ਵਧੀਆ'
  },
  paymentDetails: {
    en: 'Payment Details',
    hi: 'भुगतान विवरण',
    mr: 'पेमेंट तपशील',
    gu: 'પેમેન્ટ વિગતો',
    ta: 'பேமென்ட் விவரங்கள்',
    te: 'పేమెంట్ వివరాలు',
    kn: 'ಪಾವತಿ ವಿವರಗಳು',
    bn: 'পেমেন্ট বিবরণ',
    pa: 'ਭੁਗਤਾਨ ਵੇਰਵੇ'
  },
  plan: {
    en: 'Plan',
    hi: 'प्लान',
    mr: 'प्लॅन',
    gu: 'પ્લાન',
    ta: 'திட்டம்',
    te: 'ప్లాన్',
    kn: 'ಪ್ಲಾನ್',
    bn: 'প্ল্যান',
    pa: 'ਪਲਾਨ'
  },
  duration: {
    en: 'Duration',
    hi: 'अवधि',
    mr: 'कालावधी',
    gu: 'સમયગાળો',
    ta: 'காலம்',
    te: 'వ్యవధి',
    kn: 'ಅವಧಿ',
    bn: 'সময়কাল',
    pa: 'ਮਿਆਦ'
  },
  payViaUpi: {
    en: 'Pay via UPI',
    hi: 'UPI से भुगतान करें',
    mr: 'UPI द्वारे पैसे भरा',
    gu: 'UPI દ્વારા ચૂકવો',
    ta: 'UPI மூலம் செலுத்துங்கள்',
    te: 'UPI ద్వారా చెల్లించండి',
    kn: 'UPI ಮೂಲಕ ಪಾವತಿಸಿ',
    bn: 'UPI দিয়ে পেমেন্ট করুন',
    pa: 'UPI ਰਾਹੀਂ ਭੁਗਤਾਨ ਕਰੋ'
  },
  orScanQR: {
    en: 'Or scan QR code in your UPI app',
    hi: 'या अपने UPI ऐप में QR कोड स्कैन करें',
    mr: 'किंवा तुमच्या UPI ऐपमध्ये QR कोड स्कॅन करा',
    gu: 'અથવા તમારી UPI એપમાં QR કોડ સ્કેન કરો',
    ta: 'அல்லது உங்கள் UPI பயன்பாட்டில் QR குறியீட்டை ஸ்கேன் செய்யவும்',
    te: 'లేదా మీ UPI యాప్‌లో QR కోడ్ స్కాన్ చేయండి',
    kn: 'ಅಥವಾ ನಿಮ್ಮ UPI ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿ QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
    bn: 'অথবা আপনার UPI অ্যাপে QR কোড স্ক্যান করুন',
    pa: 'ਜਾਂ ਆਪਣੀ UPI ਐਪ ਵਿੱਚ QR ਕੋਡ ਸਕੈਨ ਕਰੋ'
  },
  utrNumber: {
    en: 'UTR/Reference Number',
    hi: 'UTR/संदर्भ नंबर',
    mr: 'UTR/संदर्भ क्रमांक',
    gu: 'UTR/સંદર્ભ નંબર',
    ta: 'UTR/குறிப்பு எண்',
    te: 'UTR/రిఫరెన్స్ నంబర్',
    kn: 'UTR/ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ',
    bn: 'UTR/রেফারেন্স নম্বর',
    pa: 'UTR/ਹਵਾਲਾ ਨੰਬਰ'
  },
  paymentDate: {
    en: 'Payment Date',
    hi: 'भुगतान तिथि',
    mr: 'पेमेंट तारीख',
    gu: 'પેમેન્ટ તારીખ',
    ta: 'பேமென்ட் தேதி',
    te: 'పేమెంట్ తేదీ',
    kn: 'ಪಾವತಿ ದಿನಾಂಕ',
    bn: 'পেমেন্ট তারিখ',
    pa: 'ਭੁਗਤਾਨ ਮਿਤੀ'
  },
  paymentTime: {
    en: 'Payment Time',
    hi: 'भुगतान समय',
    mr: 'पेमेंट वेळ',
    gu: 'પેમેન્ટ સમય',
    ta: 'பேமென்ட் நேரம்',
    te: 'పేమెంట్ సమయం',
    kn: 'ಪಾವತಿ ಸಮಯ',
    bn: 'পেমেন্ট সময়',
    pa: 'ਭੁਗਤਾਨ ਸਮਾਂ'
  },
  paymentScreenshot: {
    en: 'Payment Screenshot',
    hi: 'भुगतान स्क्रीनशॉट',
    mr: 'पेमेंट स्क्रीनशॉट',
    gu: 'પેમેન્ટ સ્ક્રીનશોટ',
    ta: 'பேமென்ட் ஸ்கிரீன்ஷாட்',
    te: 'పేమెంట్ స్క్రీన్‌షాట్',
    kn: 'ಪಾವತಿ ಸ್ಕ್ರೀನ್‌ಶಾಟ್',
    bn: 'পেমেন্ট স্ক্রিনশট',
    pa: 'ਭੁਗਤਾਨ ਸਕ੍ਰੀਨਸ਼ਾਟ'
  },
  submitPayment: {
    en: 'Submit Payment',
    hi: 'भुगतान जमा करें',
    mr: 'पेमेंट सबमिट करा',
    gu: 'પેમેન્ટ સબમિટ કરો',
    ta: 'பேமென்ட் சமர்ப்பிக்கவும்',
    te: 'పేమెంట్ సబ్మిట్ చేయండి',
    kn: 'ಪಾವತಿ ಸಲ್ಲಿಸಿ',
    bn: 'পেমেন্ট জমা দিন',
    pa: 'ਭੁਗਤਾਨ ਜਮ੍ਹਾਂ ਕਰੋ'
  },
  paymentSubmitted: {
    en: 'Payment Submitted!',
    hi: 'भुगतान जमा हो गया!',
    mr: 'पेमेंट सबमिट झाले!',
    gu: 'પેમેન્ટ સબમિટ થયું!',
    ta: 'பேமென்ட் சமர்ப்பிக்கப்பட்டது!',
    te: 'పేమెంట్ సబ్మిట్ అయింది!',
    kn: 'ಪಾವತಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!',
    bn: 'পেমেন্ট জমা হয়েছে!',
    pa: 'ਭੁਗਤਾਨ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ!'
  },
  verifyAndActivate: {
    en: 'We will verify your payment and activate your {plan} subscription within 24 hours.',
    hi: 'हम आपके भुगतान को सत्यापित करेंगे और 24 घंटे के भीतर आपकी {plan} सदस्यता सक्रिय करेंगे।',
    mr: 'आम्ही तुमचे पेमेंट सत्यापित करू आणि 24 तासांच्या आत तुमची {plan} सदस्यता सक्रिय करू.',
    gu: 'અમે તમારી ચુકવણી ચકાસીશું અને 24 કલાકની અંદર તમારી {plan} સબ્સ્ક્રિપ્શન સક્રિય કરીશું.',
    ta: 'உங்கள் பேமென்ட்டை சரிபார்த்து 24 மணி நேரத்திற்குள் உங்கள் {plan} சந்தாவை செயல்படுத்துவோம்.',
    te: 'మేము మీ పేమెంట్‌ను ధృవీకరించి 24 గంటల్లో మీ {plan} సబ్‌స్క్రిప్షన్‌ను యాక్టివేట్ చేస్తాము.',
    kn: 'ನಾವು ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ಪರಿಶೀಲಿಸುತ್ತೇವೆ ಮತ್ತು 24 ಗಂಟೆಗಳಲ್ಲಿ ನಿಮ್ಮ {plan} ಚಂದಾವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತೇವೆ.',
    bn: 'আমরা আপনার পেমেন্ট যাচাই করব এবং 24 ঘন্টার মধ্যে আপনার {plan} সাবস্ক্রিপশন সক্রিয় করব।',
    pa: 'ਅਸੀਂ ਤੁਹਾਡੇ ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਾਂਗੇ ਅਤੇ 24 ਘੰਟਿਆਂ ਦੇ ਅੰਦਰ ਤੁਹਾਡੀ {plan} ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਐਕਟਿਵ ਕਰਾਂਗੇ।'
  },
  backToDashboard: {
    en: 'Back to Dashboard',
    hi: 'डैशबोर्ड पर वापस जाएं',
    mr: 'डॅशबोर्डवर परत जा',
    gu: 'ડેશબોર્ડ પર પાછા જાઓ',
    ta: 'டாஷ்போர்டுக்குத் திரும்பு',
    te: 'డాష్‌బోర్డ్‌కు తిరిగి వెళ్ళండి',
    kn: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂತಿರುಗಿ',
    bn: 'ড্যাশবোর্ডে ফিরে যান',
    pa: 'ਡੈਸ਼ਬੋਰਡ ਤੇ ਵਾਪਸ ਜਾਓ'
  },
  daysRemaining: {
    en: '{count} days remaining',
    hi: '{count} दिन शेष',
    mr: '{count} दिवस शिल्लक',
    gu: '{count} દિવસ બાકી',
    ta: '{count} நாட்கள் மீதம்',
    te: '{count} రోజులు మిగిలి ఉన్నాయి',
    kn: '{count} ದಿನಗಳು ಉಳಿದಿವೆ',
    bn: '{count} দিন বাকি',
    pa: '{count} ਦਿਨ ਬਾਕੀ'
  },
  expiredRenew: {
    en: 'Expired - Renew to continue benefits',
    hi: 'समाप्त - लाभ जारी रखने के लिए नवीनीकरण करें',
    mr: 'समाप्त - लाभ सुरू ठेवण्यासाठी नूतनीकरण करा',
    gu: 'સમાપ્ત - લાભો ચાલુ રાખવા માટે નવીકરણ કરો',
    ta: 'காலாவதியானது - பலன்களைத் தொடர புதுப்பிக்கவும்',
    te: 'గడువు ముగిసింది - ప్రయోజనాలు కొనసాగించడానికి రెన్యూ చేయండి',
    kn: 'ಅವಧಿ ಮುಗಿದಿದೆ - ಪ್ರಯೋಜನಗಳನ್ನು ಮುಂದುವರಿಸಲು ನವೀಕರಿಸಿ',
    bn: 'মেয়াদ শেষ - সুবিধা চালু রাখতে রিনিউ করুন',
    pa: 'ਮਿਆਦ ਖਤਮ - ਲਾਭ ਜਾਰੀ ਰੱਖਣ ਲਈ ਨਵਿਆਓ'
  },
  freePlanUpgrade: {
    en: 'Free plan - Upgrade for more benefits!',
    hi: 'मुफ्त प्लान - अधिक लाभों के लिए अपग्रेड करें!',
    mr: 'मोफत प्लॅन - अधिक लाभांसाठी अपग्रेड करा!',
    gu: 'મફત પ્લાન - વધુ લાભો માટે અપગ્રેડ કરો!',
    ta: 'இலவச திட்டம் - மேலும் பலன்களுக்கு மேம்படுத்துங்கள்!',
    te: 'ఉచిత ప్లాన్ - మరిన్ని ప్రయోజనాల కోసం అప్‌గ్రేడ్ చేయండి!',
    kn: 'ಉಚಿತ ಪ್ಲಾನ್ - ಹೆಚ್ಚಿನ ಪ್ರಯೋಜನಗಳಿಗಾಗಿ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ!',
    bn: 'বিনামূল্যে প্ল্যান - আরও সুবিধার জন্য আপগ্রেড করুন!',
    pa: 'ਮੁਫ਼ਤ ਪਲਾਨ - ਹੋਰ ਲਾਭਾਂ ਲਈ ਅੱਪਗ੍ਰੇਡ ਕਰੋ!'
  },

  // ==================== FREE USER ACCESS ERROR MESSAGES ====================
  paidSubscriptionRequiredMarketplace: {
    en: 'Paid subscription required to access Marketplace. Upgrade to Startup, Growth or Elite plan to enjoy shopping!',
    hi: 'मार्केटप्लेस एक्सेस के लिए पेड सब्सक्रिप्शन आवश्यक है। खरीदारी का आनंद लेने के लिए Startup, Growth या Elite प्लान में अपग्रेड करें!',
    mr: 'मार्केटप्लेस वापरण्यासाठी पेड सब्सक्रिप्शन आवश्यक आहे. खरेदीचा आनंद घेण्यासाठी Startup, Growth किंवा Elite प्लान मध्ये अपग्रेड करा!',
    gu: 'માર્કેટપ્લેસ એક્સેસ માટે પેઇડ સબ્સ્ક્રિપ્શન જરૂરી છે. શોપિંગનો આનંદ માણવા Startup, Growth અથવા Elite પ્લાનમાં અપગ્રેડ કરો!',
    ta: 'மார்க்கெட்பிளேஸ் அணுக பணம் செலுத்திய சந்தா தேவை. ஷாப்பிங் அனுபவிக்க Startup, Growth அல்லது Elite திட்டத்திற்கு மேம்படுத்துங்கள்!',
    te: 'మార్కెట్‌ప్లేస్ యాక్సెస్ కోసం చెల్లింపు సబ్‌స్క్రిప్షన్ అవసరం. షాపింగ్ ఆనందించడానికి Startup, Growth లేదా Elite ప్లాన్‌కి అప్‌గ్రేడ్ చేయండి!',
    kn: 'ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್ ಪ್ರವೇಶಕ್ಕೆ ಪಾವತಿಸಿದ ಚಂದಾ ಅಗತ್ಯ. ಶಾಪಿಂಗ್ ಆನಂದಿಸಲು Startup, Growth ಅಥವಾ Elite ಪ್ಲಾನ್‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ!',
    bn: 'মার্কেটপ্লেস অ্যাক্সেসের জন্য পেইড সাবস্ক্রিপশন প্রয়োজন। শপিং উপভোগ করতে Startup, Growth বা Elite প্ল্যানে আপগ্রেড করুন!',
    pa: 'ਮਾਰਕਿਟਪਲੇਸ ਐਕਸੈਸ ਲਈ ਪੇਡ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਲੋੜੀਂਦੀ ਹੈ। ਸ਼ੌਪਿੰਗ ਦਾ ਆਨੰਦ ਲੈਣ ਲਈ Startup, Growth ਜਾਂ Elite ਪਲਾਨ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ!'
  },
  paidSubscriptionRequiredBillPayments: {
    en: 'Paid subscription required to access Bill Payments. Upgrade to Startup, Growth or Elite plan to enjoy this service!',
    hi: 'बिल पेमेंट एक्सेस के लिए पेड सब्सक्रिप्शन आवश्यक है। इस सेवा का आनंद लेने के लिए Startup, Growth या Elite प्लान में अपग्रेड करें!',
    mr: 'बिल पेमेंट वापरण्यासाठी पेड सब्सक्रिप्शन आवश्यक आहे. या सेवेचा आनंद घेण्यासाठी Startup, Growth किंवा Elite प्लान मध्ये अपग्रेड करा!',
    gu: 'બિલ પેમેન્ટ એક્સેસ માટે પેઇડ સબ્સ્ક્રિપ્શન જરૂરી છે. આ સેવાનો આનંદ માણવા Startup, Growth અથવા Elite પ્લાનમાં અપગ્રેડ કરો!',
    ta: 'பில் பேமென்ட்ஸ் அணுக பணம் செலுத்திய சந்தா தேவை. இந்த சேவையை அனுபவிக்க Startup, Growth அல்லது Elite திட்டத்திற்கு மேம்படுத்துங்கள்!',
    te: 'బిల్ పేమెంట్స్ యాక్సెస్ కోసం చెల్లింపు సబ్‌స్క్రిప్షన్ అవసరం. ఈ సేవను ఆనందించడానికి Startup, Growth లేదా Elite ప్లాన్‌కి అప్‌గ్రేడ్ చేయండి!',
    kn: 'ಬಿಲ್ ಪೇಮೆಂಟ್ಸ್ ಪ್ರವೇಶಕ್ಕೆ ಪಾವತಿಸಿದ ಚಂದಾ ಅಗತ್ಯ. ಈ ಸೇವೆಯನ್ನು ಆನಂದಿಸಲು Startup, Growth ಅಥವಾ Elite ಪ್ಲಾನ್‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ!',
    bn: 'বিল পেমেন্টস অ্যাক্সেসের জন্য পেইড সাবস্ক্রিপশন প্রয়োজন। এই সেবা উপভোগ করতে Startup, Growth বা Elite প্ল্যানে আপগ্রেড করুন!',
    pa: 'ਬਿੱਲ ਪੇਮੈਂਟਸ ਐਕਸੈਸ ਲਈ ਪੇਡ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਲੋੜੀਂਦੀ ਹੈ। ਇਸ ਸੇਵਾ ਦਾ ਆਨੰਦ ਲੈਣ ਲਈ Startup, Growth ਜਾਂ Elite ਪਲਾਨ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ!'
  },
  paidSubscriptionRequiredGiftVouchers: {
    en: 'Paid subscription required to redeem Gift Vouchers. Upgrade to Startup, Growth or Elite plan to enjoy this service!',
    hi: 'गिफ्ट वाउचर रिडीम करने के लिए पेड सब्सक्रिप्शन आवश्यक है। इस सेवा का आनंद लेने के लिए Startup, Growth या Elite प्लान में अपग्रेड करें!',
    mr: 'गिफ्ट व्हाउचर रिडीम करण्यासाठी पेड सब्सक्रिप्शन आवश्यक आहे. या सेवेचा आनंद घेण्यासाठी Startup, Growth किंवा Elite प्लान मध्ये अपग्रेड करा!',
    gu: 'ગિફ્ટ વાઉચર રિડીમ કરવા માટે પેઇડ સબ્સ્ક્રિપ્શન જરૂરી છે. આ સેવાનો આનંદ માણવા Startup, Growth અથવા Elite પ્લાનમાં અપગ્રેડ કરો!',
    ta: 'கிஃப்ட் வௌச்சர் ரிடீம் செய்ய பணம் செலுத்திய சந்தா தேவை. இந்த சேவையை அனுபவிக்க Startup, Growth அல்லது Elite திட்டத்திற்கு மேம்படுத்துங்கள்!',
    te: 'గిఫ్ట్ వౌచర్‌లు రిడీమ్ చేయడానికి చెల్లింపు సబ్‌స్క్రిప్షన్ అవసరం. ఈ సేవను ఆనందించడానికి Startup, Growth లేదా Elite ప్లాన్‌కి అప్‌గ్రేడ్ చేయండి!',
    kn: 'ಗಿಫ್ಟ್ ವೋಚರ್‌ಗಳನ್ನು ರಿಡೀಮ್ ಮಾಡಲು ಪಾವತಿಸಿದ ಚಂದಾ ಅಗತ್ಯ. ಈ ಸೇವೆಯನ್ನು ಆನಂದಿಸಲು Startup, Growth ಅಥವಾ Elite ಪ್ಲಾನ್‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ!',
    bn: 'গিফট ভাউচার রিডিম করতে পেইড সাবস্ক্রিপশন প্রয়োজন। এই সেবা উপভোগ করতে Startup, Growth বা Elite প্ল্যানে আপগ্রেড করুন!',
    pa: 'ਗਿਫਟ ਵਾਊਚਰ ਰੀਡੀਮ ਕਰਨ ਲਈ ਪੇਡ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਲੋੜੀਂਦੀ ਹੈ। ਇਸ ਸੇਵਾ ਦਾ ਆਨੰਦ ਲੈਣ ਲਈ Startup, Growth ਜਾਂ Elite ਪਲਾਨ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ!'
  },
  paidSubscriptionRequiredShopping: {
    en: 'Paid subscription required to add items to cart. Upgrade to Startup, Growth or Elite plan to shop!',
    hi: 'कार्ट में आइटम जोड़ने के लिए पेड सब्सक्रिप्शन आवश्यक है। खरीदारी के लिए Startup, Growth या Elite प्लान में अपग्रेड करें!',
    mr: 'कार्ट मध्ये आयटम जोडण्यासाठी पेड सब्सक्रिप्शन आवश्यक आहे. खरेदीसाठी Startup, Growth किंवा Elite प्लान मध्ये अपग्रेड करा!',
    gu: 'કાર્ટમાં આઈટમ ઉમેરવા માટે પેઇડ સબ્સ્ક્રિપ્શન જરૂરી છે. શોપિંગ માટે Startup, Growth અથવા Elite પ્લાનમાં અપગ્રેડ કરો!',
    ta: 'கார்ட்டில் பொருட்களைச் சேர்க்க பணம் செலுத்திய சந்தா தேவை. ஷாப்பிங் செய்ய Startup, Growth அல்லது Elite திட்டத்திற்கு மேம்படுத்துங்கள்!',
    te: 'కార్ట్‌లో ఐటెమ్‌లు జోడించడానికి చెల్లింపు సబ్‌స్క్రిప్షన్ అవసరం. షాపింగ్ కోసం Startup, Growth లేదా Elite ప్లాన్‌కి అప్‌గ్రేడ్ చేయండి!',
    kn: 'ಕಾರ್ಟ್‌ಗೆ ಐಟಂಗಳನ್ನು ಸೇರಿಸಲು ಪಾವತಿಸಿದ ಚಂದಾ ಅಗತ್ಯ. ಶಾಪಿಂಗ್ ಮಾಡಲು Startup, Growth ಅಥವಾ Elite ಪ್ಲಾನ್‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ!',
    bn: 'কার্টে আইটেম যোগ করতে পেইড সাবস্ক্রিপশন প্রয়োজন। শপিং করতে Startup, Growth বা Elite প্ল্যানে আপগ্রেড করুন!',
    pa: 'ਕਾਰਟ ਵਿੱਚ ਆਈਟਮ ਜੋੜਨ ਲਈ ਪੇਡ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਲੋੜੀਂਦੀ ਹੈ। ਸ਼ੌਪਿੰਗ ਲਈ Startup, Growth ਜਾਂ Elite ਪਲਾਨ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ!'
  },

  // ==================== SIDEBAR MENU ====================
  myOrders: {
    en: 'My Orders',
    hi: 'मेरे ऑर्डर',
    mr: 'माझे ऑर्डर',
    gu: 'મારા ઓર્ડર',
    ta: 'எனது ஆர்டர்கள்',
    te: 'నా ఆర్డర్లు',
    kn: 'ನನ್ನ ಆರ್ಡರ್‌ಗಳು',
    bn: 'আমার অর্ডার',
    pa: 'ਮੇਰੇ ਆਰਡਰ'
  },
  myProfile: {
    en: 'My Profile',
    hi: 'मेरी प्रोफ़ाइल',
    mr: 'माझी प्रोफाइल',
    gu: 'મારી પ્રોફાઈલ',
    ta: 'என் சுயவிவரம்',
    te: 'నా ప్రొఫైల్',
    kn: 'ನನ್ನ ಪ್ರೊಫೈಲ್',
    bn: 'আমার প্রোফাইল',
    pa: 'ਮੇਰੀ ਪ੍ਰੋਫਾਈਲ'
  },
  support: {
    en: 'Support',
    hi: 'सहायता',
    mr: 'सहाय्य',
    gu: 'સહાય',
    ta: 'ஆதரவு',
    te: 'సహాయం',
    kn: 'ಬೆಂಬಲ',
    bn: 'সহায়তা',
    pa: 'ਸਹਾਇਤਾ'
  },
  termsAndConditions: {
    en: 'Terms & Conditions',
    hi: 'नियम और शर्तें',
    mr: 'नियम व अटी',
    gu: 'નિયમો અને શરતો',
    ta: 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
    te: 'నిబంధనలు మరియు షరతులు',
    kn: 'ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು',
    bn: 'শর্তাবলী',
    pa: 'ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ'
  },
  privacyPolicy: {
    en: 'Privacy Policy',
    hi: 'गोपनीयता नीति',
    mr: 'गोपनीयता धोरण',
    gu: 'ગોપનીયતા નીતિ',
    ta: 'தனியுரிமைக் கொள்கை',
    te: 'గోప్యతా విధానం',
    kn: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    bn: 'গোপনীয়তা নীতি',
    pa: 'ਗੋਪਨੀਯਤਾ ਨੀਤੀ'
  },
  accountAndSupport: {
    en: 'Account & Support',
    hi: 'खाता और सहायता',
    mr: 'खाते आणि सहाय्य',
    gu: 'એકાઉન્ટ અને સહાય',
    ta: 'கணக்கு மற்றும் ஆதரவு',
    te: 'ఖాతా మరియు సహాయం',
    kn: 'ಖಾತೆ ಮತ್ತು ಬೆಂಬಲ',
    bn: 'অ্যাকাউন্ট এবং সহায়তা',
    pa: 'ਖਾਤਾ ਅਤੇ ਸਹਾਇਤਾ'
  },

  // ==================== DAILY REWARDS / MINING ====================
  dailyRewards: {
    en: 'Daily Rewards',
    hi: 'दैनिक पुरस्कार',
    mr: 'दैनिक बक्षिसे',
    gu: 'દૈનિક પુરસ્કાર',
    ta: 'தினசரி வெகுமதிகள்',
    te: 'రోజువారీ రివార్డ్‌లు',
    kn: 'ದೈನಿಕ ಪುರಸ್ಕಾರಗಳು',
    bn: 'দৈনিক পুরস্কার',
    pa: 'ਰੋਜ਼ਾਨਾ ਇਨਾਮ'
  },
  startSession: {
    en: 'Start Session',
    hi: 'सत्र शुरू करें',
    mr: 'सत्र सुरू करा',
    gu: 'સત્ર શરૂ કરો',
    ta: 'அமர்வைத் தொடங்கு',
    te: 'సెషన్ ప్రారంభించండి',
    kn: 'ಸೆಷನ್ ಪ್ರಾರಂಭಿಸಿ',
    bn: 'সেশন শুরু করুন',
    pa: 'ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ'
  },
  sessionActive: {
    en: 'Session Active',
    hi: 'सत्र सक्रिय',
    mr: 'सत्र सक्रिय',
    gu: 'સત્ર સક્રિય',
    ta: 'அமர்வு செயலில் உள்ளது',
    te: 'సెషన్ యాక్టివ్',
    kn: 'ಸೆಷನ್ ಸಕ್ರಿಯ',
    bn: 'সেশন সক্রিয়',
    pa: 'ਸੈਸ਼ਨ ਐਕਟਿਵ'
  },
  timeRemaining: {
    en: 'Time Remaining',
    hi: 'शेष समय',
    mr: 'उर्वरित वेळ',
    gu: 'બાકી સમય',
    ta: 'மீதமுள்ள நேரம்',
    te: 'మిగిలిన సమయం',
    kn: 'ಉಳಿದ ಸಮಯ',
    bn: 'অবশিষ্ট সময়',
    pa: 'ਬਾਕੀ ਸਮਾਂ'
  },
  sessionEarnings: {
    en: 'Session Earnings',
    hi: 'सत्र की कमाई',
    mr: 'सत्राची कमाई',
    gu: 'સત્રની કમાણી',
    ta: 'அமர்வு வருவாய்',
    te: 'సెషన్ ఆదాయం',
    kn: 'ಸೆಷನ್ ಗಳಿಕೆ',
    bn: 'সেশন আয়',
    pa: 'ਸੈਸ਼ਨ ਕਮਾਈ'
  },
  currentBalance: {
    en: 'Current Balance',
    hi: 'वर्तमान बैलेंस',
    mr: 'वर्तमान शिल्लक',
    gu: 'વર્તમાન બેલેન્સ',
    ta: 'தற்போதைய இருப்பு',
    te: 'ప్రస్తుత బ్యాలెన్స్',
    kn: 'ಪ್ರಸ್ತುತ ಬ್ಯಾಲೆನ್ಸ್',
    bn: 'বর্তমান ব্যালেন্স',
    pa: 'ਮੌਜੂਦਾ ਬੈਲੇਂਸ'
  },
  rewardRate: {
    en: 'Reward Rate',
    hi: 'पुरस्कार दर',
    mr: 'बक्षीस दर',
    gu: 'પુરસ્કાર દર',
    ta: 'வெகுமதி விகிதம்',
    te: 'రివార్డ్ రేటు',
    kn: 'ಪುರಸ್ಕಾರ ದರ',
    bn: 'পুরস্কার হার',
    pa: 'ਇਨਾਮ ਦਰ'
  },
  perHour: {
    en: '/hour',
    hi: '/घंटा',
    mr: '/तास',
    gu: '/કલાક',
    ta: '/மணி',
    te: '/గంట',
    kn: '/ಗಂಟೆ',
    bn: '/ঘন্টা',
    pa: '/ਘੰਟਾ'
  },
  // (duplicate `totalEarned` entry removed — see definition earlier in file)
  collectRewards: {
    en: 'Collect Rewards',
    hi: 'पुरस्कार इकट्ठा करें',
    mr: 'बक्षीस गोळा करा',
    gu: 'પુરસ્કાર એકત્ર કરો',
    ta: 'வெகுமதிகளைச் சேகரிக்கவும்',
    te: 'రివార్డ్‌లను సేకరించండి',
    kn: 'ಪುರಸ್ಕಾರಗಳನ್ನು ಸಂಗ್ರಹಿಸಿ',
    bn: 'পুরস্কার সংগ্রহ করুন',
    pa: 'ਇਨਾਮ ਇਕੱਠੇ ਕਰੋ'
  },
  collecting: {
    en: 'Collecting...',
    hi: 'इकट्ठा कर रहे हैं...',
    mr: 'गोळा करत आहे...',
    gu: 'એકત્ર કરી રહ્યા છીએ...',
    ta: 'சேகரிக்கிறது...',
    te: 'సేకరిస్తోంది...',
    kn: 'ಸಂಗ್ರಹಿಸುತ್ತಿದೆ...',
    bn: 'সংগ্রহ করা হচ্ছে...',
    pa: 'ਇਕੱਠਾ ਕਰ ਰਿਹਾ ਹੈ...'
  },
  processing: {
    en: 'Processing',
    hi: 'प्रोसेसिंग',
    mr: 'प्रक्रिया सुरू',
    gu: 'પ્રક્રિયા',
    ta: 'செயலாக்கம்',
    te: 'ప్రాసెసింగ్',
    kn: 'ಪ್ರಕ್ರಿಯೆ',
    bn: 'প্রক্রিয়াকরণ',
    pa: 'ਪ੍ਰੋਸੈਸਿੰਗ'
  },
  // (duplicate `yourStats` entry removed — see definition earlier in file)
  freeUserWarning: {
    en: 'Free User: PRC valid for 2 days',
    hi: 'फ्री यूजर: PRC 2 दिनों के लिए वैध',
    mr: 'फ्री युजर: PRC 2 दिवसांसाठी वैध',
    gu: 'ફ્રી યુઝર: PRC 2 દિવસ માટે માન્ય',
    ta: 'இலவச பயனர்: PRC 2 நாட்களுக்கு செல்லுபடியாகும்',
    te: 'ఫ్రీ యూజర్: PRC 2 రోజులు చెల్లుబాటు',
    kn: 'ಉಚಿತ ಬಳಕೆದಾರ: PRC 2 ದಿನಗಳವರೆಗೆ ಮಾನ್ಯ',
    bn: 'ফ্রি ইউজার: PRC 2 দিনের জন্য বৈধ',
    pa: 'ਫ੍ਰੀ ਯੂਜ਼ਰ: PRC 2 ਦਿਨਾਂ ਲਈ ਵੈਧ'
  },

  tapToEarn: {
    en: 'Tap to Earn',
    hi: 'टैप करें और कमाएं',
    mr: 'टॅप करा आणि कमवा',
    gu: 'ટેપ કરો અને કમાઓ',
    ta: 'தட்டி சம்பாதிக்கவும்',
    te: 'ట్యాప్ చేసి సంపాదించండి',
    kn: 'ಟ್ಯಾಪ್ ಮಾಡಿ ಗಳಿಸಿ',
    bn: 'ট্যাপ করে আয় করুন',
    pa: 'ਟੈਪ ਕਰੋ ਅਤੇ ਕਮਾਓ'
  },
  tapsToday: {
    en: 'taps today',
    hi: 'आज के टैप',
    mr: 'आजचे टॅप्स',
    gu: 'આજના ટેપ',
    ta: 'இன்றைய தட்டல்கள்',
    te: 'ఈరోజు ట్యాప్‌లు',
    kn: 'ಇಂದಿನ ಟ್ಯಾಪ್‌ಗಳು',
    bn: 'আজকের ট্যাপ',
    pa: 'ਅੱਜ ਦੇ ਟੈਪ'
  },
  remaining: {
    en: 'remaining',
    hi: 'शेष',
    mr: 'बाकी',
    gu: 'બાકી',
    ta: 'மீதம்',
    te: 'మిగిలింది',
    kn: 'ಉಳಿದಿದೆ',
    bn: 'বাকি',
    pa: 'ਬਾਕੀ'
  },
  earned: {
    en: 'Earned',
    hi: 'कमाया',
    mr: 'मिळवले',
    gu: 'કમાયું',
    ta: 'சம்பாதித்தது',
    te: 'సంపాదించారు',
    kn: 'ಗಳಿಸಿದ',
    bn: 'আয় করেছেন',
    pa: 'ਕਮਾਇਆ'
  },
  dailyLimitReached: {
    en: 'Daily limit reached!',
    hi: 'दैनिक सीमा पूर्ण!',
    mr: 'दैनिक मर्यादा पूर्ण!',
    gu: 'દૈનિક મર્યાદા પૂર્ણ!',
    ta: 'தினசரி வரம்பு எட்டியது!',
    te: 'రోజువారీ పరిమితి చేరింది!',
    kn: 'ದೈನಿಕ ಮಿತಿ ತಲುಪಿದೆ!',
    bn: 'দৈনিক সীমা পৌঁছে গেছে!',
    pa: 'ਰੋਜ਼ਾਨਾ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ!'
  },
  tapFastToEarn: {
    en: 'Tap fast to earn PRC!',
    hi: 'PRC कमाने के लिए तेजी से टैप करें!',
    mr: 'PRC मिळवण्यासाठी वेगाने टॅप करा!',
    gu: 'PRC કમાવવા માટે ઝડપથી ટેપ કરો!',
    ta: 'PRC சம்பாதிக்க வேகமாக தட்டுங்கள்!',
    te: 'PRC సంపాదించడానికి వేగంగా ట్యాప్ చేయండి!',
    kn: 'PRC ಗಳಿಸಲು ವೇಗವಾಗಿ ಟ್ಯಾಪ್ ಮಾಡಿ!',
    bn: 'PRC আয় করতে দ্রুত ট্যাপ করুন!',
    pa: 'PRC ਕਮਾਉਣ ਲਈ ਤੇਜ਼ੀ ਨਾਲ ਟੈਪ ਕਰੋ!'
  },
  howToPlay: {
    en: 'How to Play',
    hi: 'कैसे खेलें',
    mr: 'कसे खेळावे',
    gu: 'કેવી રીતે રમવું',
    ta: 'எப்படி விளையாடுவது',
    te: 'ఎలా ఆడాలి',
    kn: 'ಹೇಗೆ ಆಡುವುದು',
    bn: 'কিভাবে খেলবেন',
    pa: 'ਕਿਵੇਂ ਖੇਡਣਾ ਹੈ'
  },
  tapTheButton: {
    en: 'Tap the button as fast as you can',
    hi: 'जितनी तेजी से हो सके बटन टैप करें',
    mr: 'शक्य तितक्या वेगाने बटण टॅप करा',
    gu: 'શક્ય તેટલી ઝડપથી બટન ટેપ કરો',
    ta: 'முடிந்தவரை வேகமாக பொத்தானைத் தட்டுங்கள்',
    te: 'మీకు వీలైనంత వేగంగా బటన్‌ను ట్యాప్ చేయండి',
    kn: 'ನಿಮಗೆ ಸಾಧ್ಯವಾದಷ್ಟು ವೇಗವಾಗಿ ಬಟನ್ ಟ್ಯಾಪ್ ಮಾಡಿ',
    bn: 'যত দ্রুত পারেন বাটনে ট্যাপ করুন',
    pa: 'ਜਿੰਨੀ ਤੇਜ਼ੀ ਨਾਲ ਹੋ ਸਕੇ ਬਟਨ ਟੈਪ ਕਰੋ'
  },
  earnPerTap: {
    en: 'Earn {amount} PRC per tap',
    hi: 'प्रति टैप {amount} PRC कमाएं',
    mr: 'प्रति टॅप {amount} PRC मिळवा',
    gu: 'દરેક ટેપ પર {amount} PRC કમાઓ',
    ta: 'ஒவ்வொரு தட்டலுக்கும் {amount} PRC சம்பாதிக்கவும்',
    te: 'ప్రతి ట్యాప్‌కు {amount} PRC సంపాదించండి',
    kn: 'ಪ್ರತಿ ಟ್ಯಾಪ್‌ಗೆ {amount} PRC ಗಳಿಸಿ',
    bn: 'প্রতিটি ট্যাপে {amount} PRC আয় করুন',
    pa: 'ਹਰ ਟੈਪ ਤੇ {amount} PRC ਕਮਾਓ'
  },
  maxTapsPerDay: {
    en: 'Max {count} taps per day',
    hi: 'प्रतिदिन अधिकतम {count} टैप',
    mr: 'दररोज जास्तीत जास्त {count} टॅप्स',
    gu: 'દરરોજ મહત્તમ {count} ટેપ',
    ta: 'நாளுக்கு அதிகபட்சம் {count} தட்டல்கள்',
    te: 'రోజుకు గరిష్టంగా {count} ట్యాప్‌లు',
    kn: 'ದಿನಕ್ಕೆ ಗರಿಷ್ಠ {count} ಟ್ಯಾಪ್‌ಗಳು',
    bn: 'প্রতিদিন সর্বোচ্চ {count} ট্যাপ',
    pa: 'ਰੋਜ਼ਾਨਾ ਵੱਧ ਤੋਂ ਵੱਧ {count} ਟੈਪ'
  },
  rate: {
    en: 'Rate',
    hi: 'दर',
    mr: 'दर',
    gu: 'દર',
    ta: 'விகிதம்',
    te: 'రేటు',
    kn: 'ದರ',
    bn: 'হার',
    pa: 'ਦਰ'
  },

  // ==================== DASHBOARD SPECIFIC (Additional) ====================
  explore: {
    en: 'Explore',
    hi: 'एक्सप्लोर',
    mr: 'एक्सप्लोर',
    gu: 'એક્સપ્લોર',
    ta: 'ஆராயுங்கள்',
    te: 'అన్వేషించండి',
    kn: 'ಅನ್ವೇಷಿಸಿ',
    bn: 'এক্সপ্লোর',
    pa: 'ਐਕਸਪਲੋਰ'
  },
  redeem: {
    en: 'Redeem',
    hi: 'रिडीम',
    mr: 'रिडीम',
    gu: 'રિડીમ',
    ta: 'ரிடீம்',
    te: 'రీడీమ్',
    kn: 'ರಿಡೀಮ್',
    bn: 'রিডিম',
    pa: 'ਰੀਡੀਮ'
  },
  activity: {
    en: 'Activity',
    hi: 'गतिविधि',
    mr: 'क्रिया',
    gu: 'પ્રવૃત્તિ',
    ta: 'செயல்பாடு',
    te: 'కార్యకలాపం',
    kn: 'ಚಟುವಟಿಕೆ',
    bn: 'কার্যকলাপ',
    pa: 'ਗਤੀਵਿਧੀ'
  },
  activityLiveFeed: {
    en: 'Your activity & live feed',
    hi: 'आपकी गतिविधि और लाइव फ़ीड',
    mr: 'तुमची क्रिया आणि लाइव्ह फीड',
    gu: 'તમારી પ્રવૃત્તિ અને લાઇવ ફીડ',
    ta: 'உங்கள் செயல்பாடு & நேரடி ஊட்டம்',
    te: 'మీ కార్యకలాపం & లైవ్ ఫీడ్',
    kn: 'ನಿಮ್ಮ ಚಟುವಟಿಕೆ & ಲೈವ್ ಫೀಡ್',
    bn: 'আপনার কার্যকলাপ ও লাইভ ফিড',
    pa: 'ਤੁਹਾਡੀ ਗਤੀਵਿਧੀ ਅਤੇ ਲਾਈਵ ਫੀਡ'
  },
  amazonFlipkartMore: {
    en: 'Amazon, Flipkart & more',
    hi: 'Amazon, Flipkart और अधिक',
    mr: 'Amazon, Flipkart आणि बरेच काही',
    gu: 'Amazon, Flipkart અને વધુ',
    ta: 'Amazon, Flipkart மற்றும் பல',
    te: 'Amazon, Flipkart & మరిన్ని',
    kn: 'Amazon, Flipkart & ಹೆಚ್ಚು',
    bn: 'Amazon, Flipkart এবং আরও',
    pa: 'Amazon, Flipkart ਅਤੇ ਹੋਰ'
  },
  productsDeals: {
    en: 'Products & deals',
    hi: 'उत्पाद और डील्स',
    mr: 'उत्पादने आणि डील्स',
    gu: 'ઉત્પાદનો અને ડીલ્સ',
    ta: 'தயாரிப்புகள் & சலுகைகள்',
    te: 'ఉత్పత్తులు & డీల్స్',
    kn: 'ಉತ್ಪನ್ನಗಳು & ಡೀಲ್‌ಗಳು',
    bn: 'পণ্য ও ডিল',
    pa: 'ਉਤਪਾਦ ਅਤੇ ਡੀਲਾਂ'
  },
  startupElitePlan: {
    en: 'Startup/Elite plan',
    hi: 'Startup/Elite प्लान',
    mr: 'Startup/Elite प्लॅन',
    gu: 'Startup/Elite પ્લાન',
    ta: 'Startup/Elite திட்டம்',
    te: 'Startup/Elite ప్లాన్',
    kn: 'Startup/Elite ಪ್ಲಾನ್',
    bn: 'Startup/Elite প্ল্যান',
    pa: 'Startup/Elite ਪਲਾਨ'
  },
  card: {
    en: 'Card',
    hi: 'कार्ड',
    mr: 'कार्ड',
    gu: 'કાર્ડ',
    ta: 'கார்டு',
    te: 'కార్డ్',
    kn: 'ಕಾರ್ಡ್',
    bn: 'কার্ড',
    pa: 'ਕਾਰਡ'
  },
  planActive: {
    en: 'Plan',
    hi: 'प्लान',
    mr: 'प्लॅन',
    gu: 'પ્લાન',
    ta: 'திட்டம்',
    te: 'ప్లాన్',
    kn: 'ಪ್ಲಾನ್',
    bn: 'প্ল্যান',
    pa: 'ਪਲਾਨ'
  },
  active: {
    en: 'Active',
    hi: 'सक्रिय',
    mr: 'सक्रिय',
    gu: 'સક્રિય',
    ta: 'செயலில்',
    te: 'యాక్టివ్',
    kn: 'ಸಕ್ರಿಯ',
    bn: 'সক্রিয়',
    pa: 'ਐਕਟਿਵ'
  },
  expired: {
    en: 'Expired',
    hi: 'समाप्त',
    mr: 'समाप्त',
    gu: 'સમાપ્ત',
    ta: 'காலாவதியானது',
    te: 'గడువు ముగిసింది',
    kn: 'ಅವಧಿ ಮುಗಿದಿದೆ',
    bn: 'মেয়াদ শেষ',
    pa: 'ਮਿਆਦ ਖਤਮ'
  },
  started: {
    en: 'Started',
    hi: 'शुरू',
    mr: 'सुरू',
    gu: 'શરૂ',
    ta: 'தொடங்கியது',
    te: 'ప్రారంభమైంది',
    kn: 'ಪ್ರಾರಂಭವಾಯಿತು',
    bn: 'শুরু হয়েছে',
    pa: 'ਸ਼ੁਰੂ'
  },
  expires: {
    en: 'Expires',
    hi: 'समाप्त होता है',
    mr: 'समाप्त होतो',
    gu: 'સમાપ્ત થાય છે',
    ta: 'காலாவதி',
    te: 'గడువు ముగుస్తుంది',
    kn: 'ಅವಧಿ ಮುಗಿಯುತ್ತದೆ',
    bn: 'শেষ হচ্ছে',
    pa: 'ਖਤਮ ਹੁੰਦੀ ਹੈ'
  },
  daysLeft: {
    en: 'Days Left',
    hi: 'दिन शेष',
    mr: 'दिवस शिल्लक',
    gu: 'દિવસ બાકી',
    ta: 'நாட்கள் மீதம்',
    te: 'రోజులు మిగిలి ఉన్నాయి',
    kn: 'ದಿನಗಳು ಬಾಕಿ',
    bn: 'দিন বাকি',
    pa: 'ਦਿਨ ਬਾਕੀ'
  },
  planExpiresSoonRenew: {
    en: '⚠️ Plan expires soon - Renew Now',
    hi: '⚠️ प्लान जल्द समाप्त - अभी नवीनीकृत करें',
    mr: '⚠️ प्लॅन लवकरच समाप्त - आता नूतनीकरण करा',
    gu: '⚠️ પ્લાન ટૂંક સમયમાં સમાપ્ત - હમણાં નવીકરણ કરો',
    ta: '⚠️ திட்டம் விரைவில் முடிவடையும் - இப்போது புதுப்பிக்கவும்',
    te: '⚠️ ప్లాన్ త్వరలో ముగుస్తుంది - ఇప్పుడే రెన్యూ చేయండి',
    kn: '⚠️ ಪ್ಲಾನ್ ಶೀಘ್ರದಲ್ಲೇ ಮುಗಿಯುತ್ತದೆ - ಈಗ ನವೀಕರಿಸಿ',
    bn: '⚠️ প্ল্যান শীঘ্রই শেষ - এখনই রিনিউ করুন',
    pa: '⚠️ ਪਲਾਨ ਜਲਦੀ ਖਤਮ - ਹੁਣੇ ਨਵਿਆਓ'
  },

  // ==================== LUXURY LIFE TRANSLATIONS ====================
  luxuryImportantNotice: {
    en: '⚠️ Important Notice',
    hi: '⚠️ महत्वपूर्ण सूचना',
    mr: '⚠️ महत्त्वाची सूचना',
    gu: '⚠️ મહત્વની સૂચના',
    ta: '⚠️ முக்கிய அறிவிப்பு',
    te: '⚠️ ముఖ్యమైన నోటీసు',
    kn: '⚠️ ಮುಖ್ಯ ಸೂಚನೆ',
    bn: '⚠️ গুরুত্বপূর্ণ বিজ্ঞপ্তি',
    pa: '⚠️ ਮਹੱਤਵਪੂਰਨ ਸੂਚਨਾ'
  },
  luxuryDisclaimer: {
    en: 'The remaining 70% must be paid by the user. The company will NOT provide any financial arrangement for this. This is entirely the user\'s responsibility - via Cash or Loan.',
    hi: 'शेष 70% राशि उपयोगकर्ता को स्वयं भरनी होगी। कंपनी इसके लिए कोई वित्तीय व्यवस्था प्रदान नहीं करेगी। यह पूरी तरह से उपयोगकर्ता की जिम्मेदारी है - नकद या ऋण द्वारा।',
    mr: 'राहिलेली 70% रक्कम युजरने स्वतः भरावी लागेल. कंपनी याबाबत कोणतीही आर्थिक तरतूद करणार नाही. हे पूर्णपणे युजरची जबाबदारी आहे - Cash किंवा Loan द्वारे.',
    gu: 'બાકીના 70% વપરાશકર્તાએ ભરવા પડશે. કંપની આ માટે કોઈ નાણાકીય વ્યવસ્થા કરશે નહીં. આ સંપૂર્ણપણે વપરાશકર્તાની જવાબદારી છે - રોકડ અથવા લોન દ્વારા.',
    ta: 'மீதமுள்ள 70% பயனர் செலுத்த வேண்டும். நிறுவனம் இதற்கு எந்த நிதி ஏற்பாடும் செய்யாது. இது முழுக்க முழுக்க பயனரின் பொறுப்பு - பணம் அல்லது கடன் மூலம்.',
    te: 'మిగిలిన 70% వినియోగదారు చెల్లించాలి. కంపెనీ దీని కోసం ఎటువంటి ఆర్థిక ఏర్పాటు చేయదు. ఇది పూర్తిగా వినియోగదారు బాధ్యత - నగదు లేదా రుణం ద్వారా.',
    kn: 'ಉಳಿದ 70% ಬಳಕೆದಾರರು ಪಾವತಿಸಬೇಕು. ಕಂಪನಿ ಇದಕ್ಕೆ ಯಾವುದೇ ಹಣಕಾಸಿನ ಏರ್ಪಾಡು ಮಾಡುವುದಿಲ್ಲ. ಇದು ಸಂಪೂರ್ಣವಾಗಿ ಬಳಕೆದಾರರ ಜವಾಬ್ದಾರಿ - ನಗದು ಅಥವಾ ಸಾಲದ ಮೂಲಕ.',
    bn: 'বাকি 70% ব্যবহারকারীকে দিতে হবে। কোম্পানি এর জন্য কোনো আর্থিক ব্যবস্থা করবে না। এটি সম্পূর্ণরূপে ব্যবহারকারীর দায়িত্ব - নগদ বা ঋণের মাধ্যমে।',
    pa: 'ਬਾਕੀ 70% ਯੂਜ਼ਰ ਨੂੰ ਭਰਨਾ ਪਵੇਗਾ। ਕੰਪਨੀ ਇਸ ਲਈ ਕੋਈ ਵਿੱਤੀ ਪ੍ਰਬੰਧ ਨਹੀਂ ਕਰੇਗੀ। ਇਹ ਪੂਰੀ ਤਰ੍ਹਾਂ ਯੂਜ਼ਰ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਹੈ - ਕੈਸ਼ ਜਾਂ ਲੋਨ ਰਾਹੀਂ।'
  },
  luxurySavingsLocked: {
    en: 'Luxury savings are LOCKED and cannot be withdrawn',
    hi: 'लक्जरी बचत लॉक है और निकाली नहीं जा सकती',
    mr: 'लक्झरी सेव्हिंग्स लॉक आहेत आणि काढता येणार नाहीत',
    gu: 'લક્ઝરી સેવિંગ્સ લોક છે અને ઉપાડી શકાતી નથી',
    ta: 'சொகுசு சேமிப்பு பூட்டப்பட்டுள்ளது, திரும்பப் பெற முடியாது',
    te: 'లగ్జరీ సేవింగ్స్ లాక్ చేయబడ్డాయి మరియు విత్‌డ్రా చేయలేవు',
    kn: 'ಲಕ್ಸುರಿ ಉಳಿತಾಯ ಲಾಕ್ ಆಗಿದೆ ಮತ್ತು ಹಿಂಪಡೆಯಲಾಗುವುದಿಲ್ಲ',
    bn: 'লাক্সারি সঞ্চয় লক করা আছে এবং তোলা যাবে না',
    pa: 'ਲਗਜ਼ਰੀ ਬੱਚਤ ਲਾਕ ਹੈ ਅਤੇ ਕਢਵਾਈ ਨਹੀਂ ਜਾ ਸਕਦੀ'
  },
  luxuryDownPaymentCovers: {
    en: 'Down payment covers 30% of product value (via your PRC savings)',
    hi: 'डाउन पेमेंट उत्पाद मूल्य का 30% कवर करता है (आपकी PRC बचत द्वारा)',
    mr: 'डाउन पेमेंट उत्पादन मूल्याच्या 30% कव्हर करते (तुमच्या PRC बचतीद्वारे)',
    gu: 'ડાઉન પેમેન્ટ ઉત્પાદન મૂલ્યના 30% આવરી લે છે (તમારી PRC બચત દ્વારા)',
    ta: 'டவுன் பேமெண்ட் தயாரிப்பு மதிப்பில் 30% உள்ளடக்கியது (உங்கள் PRC சேமிப்பு மூலம்)',
    te: 'డౌన్ పేమెంట్ ఉత్పత్తి విలువలో 30% కవర్ చేస్తుంది (మీ PRC సేవింగ్స్ ద్వారా)',
    kn: 'ಡೌನ್ ಪೇಮೆಂಟ್ ಉತ್ಪನ್ನ ಮೌಲ್ಯದ 30% ಕವರ್ ಮಾಡುತ್ತದೆ (ನಿಮ್ಮ PRC ಉಳಿತಾಯದ ಮೂಲಕ)',
    bn: 'ডাউন পেমেন্ট পণ্য মূল্যের 30% কভার করে (আপনার PRC সঞ্চয়ের মাধ্যমে)',
    pa: 'ਡਾਊਨ ਪੇਮੈਂਟ ਉਤਪਾਦ ਮੁੱਲ ਦਾ 30% ਕਵਰ ਕਰਦੀ ਹੈ (ਤੁਹਾਡੀ PRC ਬੱਚਤ ਰਾਹੀਂ)'
  },
  luxuryClaimAt50: {
    en: 'Claim available at 50% completion (admin approval)',
    hi: '50% पूर्णता पर क्लेम उपलब्ध (एडमिन अनुमोदन)',
    mr: '50% पूर्ण झाल्यावर क्लेम उपलब्ध (अॅडमिन मंजुरी)',
    gu: '50% પૂર્ણ થયા પર ક્લેમ ઉપલબ્ધ (એડમિન મંજૂરી)',
    ta: '50% நிறைவில் கோரிக்கை கிடைக்கும் (நிர்வாக அனுமதி)',
    te: '50% పూర్తయినప్పుడు క్లెయిమ్ అందుబాటులో ఉంటుంది (అడ్మిన్ ఆమోదం)',
    kn: '50% ಪೂರ್ಣಗೊಂಡಾಗ ಕ್ಲೈಮ್ ಲಭ್ಯವಿದೆ (ಅಡ್ಮಿನ್ ಅನುಮೋದನೆ)',
    bn: '50% সম্পূর্ণ হলে ক্লেম পাওয়া যাবে (অ্যাডমিন অনুমোদন)',
    pa: '50% ਪੂਰਾ ਹੋਣ \'ਤੇ ਕਲੇਮ ਉਪਲਬਧ (ਐਡਮਿਨ ਮਨਜ਼ੂਰੀ)'
  },
  luxuryClaimsReviewed: {
    en: 'Claims are reviewed within 48 hours',
    hi: 'क्लेम 48 घंटों के भीतर समीक्षा की जाती है',
    mr: 'क्लेम 48 तासांत रिव्ह्यू केले जातात',
    gu: 'ક્લેમ 48 કલાકમાં સમીક્ષા કરવામાં આવે છે',
    ta: 'கோரிக்கைகள் 48 மணி நேரத்தில் பரிசீலிக்கப்படும்',
    te: 'క్లెయిమ్‌లు 48 గంటల్లో సమీక్షించబడతాయి',
    kn: 'ಕ್ಲೈಮ್‌ಗಳನ್ನು 48 ಗಂಟೆಗಳಲ್ಲಿ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ',
    bn: 'ক্লেম 48 ঘন্টার মধ্যে পর্যালোচনা করা হয়',
    pa: 'ਕਲੇਮ 48 ਘੰਟਿਆਂ ਵਿੱਚ ਰਿਵਿਊ ਕੀਤੇ ਜਾਂਦੇ ਹਨ'
  },
  luxuryHowItWorks: {
    en: 'How It Works',
    hi: 'यह कैसे काम करता है',
    mr: 'हे कसे काम करते',
    gu: 'આ કેવી રીતે કામ કરે છે',
    ta: 'இது எப்படி வேலை செய்கிறது',
    te: 'ఇది ఎలా పని చేస్తుంది',
    kn: 'ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ',
    bn: 'এটি কিভাবে কাজ করে',
    pa: 'ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ'
  }
};

// Language Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('paras_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('paras_language', language);
    // Set document direction for RTL languages if needed
    document.documentElement.lang = language;
  }, [language]);

  // Translation function
  const t = (key) => {
    const translation = translations[key];
    if (!translation) {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
    return translation[language] || translation['en'] || key;
  };

  // Change language
  const changeLanguage = (langCode) => {
    if (LANGUAGES.some(l => l.code === langCode)) {
      setLanguage(langCode);
    }
  };

  // Get current language info
  const currentLanguage = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t, 
      currentLanguage,
      languages: LANGUAGES,
      translations
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
